var _path, _g, _g2, _g3, _g4, _g5, _path2, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _defs, _defs2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationLoginLeftNoAnim(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 349,
    height: 375,
    viewBox: "0 0 349 375",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 482206"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 481821"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M123.24 309.592C122.474 309.543 121.708 309.38 120.975 309.136L121.236 308.355C121.904 308.583 122.588 308.713 123.289 308.762L123.224 309.592H123.24ZM125.554 309.445L125.391 308.632C126.076 308.502 126.744 308.274 127.379 307.965L127.738 308.713C127.037 309.055 126.304 309.299 125.538 309.445H125.554ZM118.906 308.127L116.999 307.005L117.423 306.289L119.329 307.412L118.906 308.127ZM129.726 307.639L129.318 306.923L131.257 305.85L131.665 306.565L129.726 307.639ZM115.093 305.898L113.186 304.776L113.61 304.06L115.516 305.182L115.093 305.898ZM133.604 305.475L133.197 304.759L135.136 303.686L135.543 304.401L133.604 305.475ZM111.28 303.669L109.373 302.547L109.797 301.831L111.703 302.953L111.28 303.669ZM93.1104 303.458L93.0289 302.628H93.1104C93.7948 302.628 94.4629 302.547 95.1147 302.384L95.3102 303.181C94.5932 303.36 93.8436 303.458 93.0941 303.458H93.1104ZM137.482 303.328L137.075 302.612L139.014 301.538L139.421 302.254L137.482 303.328ZM90.7313 303.149C89.9817 302.937 89.2647 302.644 88.5966 302.254L89.004 301.538C89.6069 301.896 90.2587 302.156 90.9431 302.351L90.715 303.149H90.7313ZM97.4775 302.335L97.0701 301.603L98.9929 300.496L99.384 301.229L97.4612 302.335H97.4775ZM107.45 301.44L107.336 301.375C106.766 301.05 106.163 300.773 105.527 300.594L105.755 299.797C106.456 300.008 107.124 300.285 107.76 300.659L107.874 300.724L107.45 301.44ZM141.344 301.164L140.937 300.448L142.876 299.374L143.283 300.09L141.344 301.164ZM86.6738 301.131L84.7672 300.008L85.1909 299.292L87.0974 300.415L86.6738 301.131ZM47.2557 300.968C46.4898 300.903 45.7239 300.724 44.9906 300.464L45.284 299.683C45.9358 299.927 46.6364 300.073 47.3371 300.155L47.2557 300.985V300.968ZM49.5696 300.887L49.4392 300.073C50.1236 299.96 50.808 299.764 51.4598 299.471L51.802 300.236C51.085 300.545 50.3518 300.773 49.5859 300.903L49.5696 300.887ZM101.356 300.48L101.16 299.667C101.845 299.504 102.545 299.423 103.23 299.423H103.458L103.442 300.252H103.23C102.594 300.252 101.959 300.318 101.339 300.464L101.356 300.48ZM42.9537 299.423L41.0309 298.316L41.4546 297.6L43.3774 298.707L42.97 299.423H42.9537ZM53.7738 299.13L53.3501 298.414L55.2566 297.291L55.6803 298.007L53.7738 299.13ZM145.222 299L144.815 298.284L146.754 297.21L147.162 297.942L145.222 299.016V299ZM82.877 298.886L80.9704 297.763L81.3941 297.047L83.3007 298.17L82.877 298.886ZM39.1407 297.226L37.2178 296.12L37.6252 295.404L39.548 296.51L39.1244 297.226H39.1407ZM57.6194 296.901L57.1957 296.185L59.1023 295.062L59.526 295.778L57.6194 296.901ZM149.101 296.836L148.693 296.12L150.632 295.046L151.04 295.762L149.101 296.836ZM79.0639 296.64L77.1574 295.518L77.581 294.802L79.4876 295.924L79.0639 296.64ZM35.3113 294.997L33.3885 293.891L33.7958 293.175L35.7187 294.281L35.3113 294.997ZM61.4488 294.655L61.0251 293.939L62.9316 292.817L63.3553 293.533L61.4488 294.655ZM75.2508 294.395L73.3443 293.272L73.768 292.556L75.6745 293.679L75.2508 294.395ZM31.4819 292.784L29.5591 291.678L29.9665 290.962L31.8893 292.068L31.4819 292.784ZM65.2782 292.491L64.936 291.726C65.6529 291.417 66.4025 291.19 67.1521 291.076L67.2825 291.889C66.5818 292.003 65.9137 292.198 65.2619 292.491H65.2782ZM71.454 292.296C70.7859 292.052 70.1015 291.889 69.4008 291.824L69.4823 290.994C70.2482 291.076 71.0141 291.238 71.7474 291.515L71.454 292.296ZM27.6525 290.571L25.7297 289.465L26.1371 288.749L28.0599 289.855L27.6525 290.571ZM23.8069 288.358L21.884 287.252L22.2914 286.536L24.2143 287.643L23.8069 288.358ZM19.9612 286.146L18.6087 285.365C18.3969 285.234 18.2013 285.088 18.0221 284.925L18.5924 284.323C18.7228 284.453 18.8694 284.551 19.0324 284.649L20.3849 285.43L19.9775 286.146H19.9612ZM16.9629 282.68V282.533C16.9629 281.72 17.2562 280.955 17.7939 280.353L18.4132 280.906C18.0221 281.346 17.7939 281.931 17.7939 282.533V282.647L16.9629 282.696V282.68ZM20.1405 279.767L19.7331 279.052L21.6559 277.945L22.0633 278.661L20.1405 279.767ZM23.9861 277.571L23.5787 276.855L25.5016 275.749L25.909 276.464L23.9861 277.571ZM27.8318 275.374L27.4244 274.658L29.3472 273.552L29.7546 274.268L27.8318 275.374ZM31.6775 273.178L31.2701 272.462L33.1929 271.355L33.6003 272.071L31.6775 273.178ZM35.5231 270.981L35.1157 270.265L37.0386 269.159L37.446 269.875L35.5231 270.981ZM39.3688 268.785L38.9614 268.069L40.8842 266.962L41.2916 267.678L39.3688 268.785ZM43.2145 266.588L42.8071 265.872L44.7299 264.766L45.1373 265.482L43.2145 266.588ZM47.0601 264.392L46.6527 263.676L48.5756 262.569L48.983 263.285L47.0601 264.392ZM50.9058 262.195L50.4984 261.479L52.4212 260.373L52.8286 261.089L50.9058 262.195ZM54.7515 259.998L54.3441 259.282L56.2669 258.176L56.6743 258.892L54.7515 259.998ZM58.5971 257.802L58.1897 257.086L60.1126 255.98L60.52 256.695L58.5971 257.802ZM62.4428 255.605L62.0354 254.889L63.9582 253.783L64.3656 254.499L62.4428 255.605ZM66.2885 253.409L65.8811 252.693L67.8039 251.586L68.2113 252.302L66.2885 253.409ZM69.9875 250.691L69.2542 250.317C69.4334 249.976 69.5312 249.585 69.5312 249.195C69.5312 248.95 69.4986 248.706 69.4171 248.479L70.2156 248.235C70.3134 248.544 70.3623 248.869 70.3623 249.195C70.3623 249.715 70.2319 250.236 70.0038 250.691H69.9875ZM68.2276 247.047L66.3048 245.94L66.7121 245.224L68.635 246.331L68.2276 247.047ZM64.3819 244.834L62.4591 243.728L62.8828 243.012L64.8056 244.118L64.3982 244.834H64.3819ZM60.5363 242.621L58.6134 241.515L59.0208 240.799L60.9436 241.905L60.52 242.621H60.5363Z",
    fill: "#222222"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_600_71030",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 202,
    width: 101,
    height: 59
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M97.8685 216.54L24.6216 258.828C21.7862 260.455 17.5169 260.975 14.6815 259.332L2.8023 252.271C-0.0330598 250.644 -0.0330598 247.991 2.8023 246.348L76.0492 204.06C78.8846 202.433 83.4798 202.433 86.3152 204.06L98.1944 211.122C101.03 212.749 100.704 214.897 97.8685 216.524V216.54Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_600_71030)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M166.377 155.654L-10.5039 257.459L-10.0889 258.178L166.792 156.373L166.377 155.654Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M168.644 156.834L-8.21973 258.67L-7.80458 259.389L169.059 157.553L168.644 156.834Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M170.695 158.146L-6.18652 259.951L-5.77149 260.67L171.11 158.865L170.695 158.146Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M173.013 159.303L-3.85059 261.139L-3.43544 261.858L173.428 160.021L173.013 159.303Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M174.92 160.654L-1.96094 262.459L-1.54592 263.178L175.335 161.373L174.92 160.654Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M177.175 161.853L0.293945 263.658L0.708966 264.377L177.59 162.572L177.175 161.853Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M179.239 163.146L2.35742 264.951L2.77244 265.67L179.654 163.865L179.239 163.146Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M181.56 164.324L4.67871 266.129L5.09374 266.848L181.975 165.043L181.56 164.324Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M183.608 165.601L6.72656 267.406L7.14158 268.125L184.023 166.32L183.608 165.601Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M185.899 166.802L9.01758 268.607L9.4326 269.326L186.314 167.521L185.899 166.802Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M187.946 168.079L11.0645 269.885L11.4795 270.604L188.361 168.798L187.946 168.079Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M190.263 169.234L13.3994 271.07L13.8146 271.789L190.678 169.953L190.263 169.234Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M192.175 170.61L15.2764 272.385L15.6913 273.104L192.59 171.329L192.175 170.61Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M194.438 171.762L17.5742 273.598L17.9894 274.317L194.853 172.48L194.438 171.762Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M196.484 173.039L19.6211 274.875L20.0362 275.594L196.9 173.758L196.484 173.039Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M198.796 174.265L21.915 276.07L22.3301 276.789L199.211 174.984L198.796 174.265Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M200.844 175.558L23.9629 277.363L24.3779 278.082L201.259 176.277L200.844 175.558Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M136.121 138.32L-40.7598 240.125L-40.3447 240.844L136.536 139.039L136.121 138.32Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M138.431 139.471L-38.4326 241.307L-38.0175 242.025L138.846 140.189L138.431 139.471Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M140.347 140.828L-36.5342 242.633L-36.1192 243.352L140.762 141.546L140.347 140.828Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M142.613 141.996L-34.25 243.832L-33.8348 244.551L143.029 142.715L142.613 141.996Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M144.665 143.32L-32.2158 245.125L-31.8008 245.844L145.08 144.039L144.665 143.32Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M146.96 144.461L-29.9033 246.297L-29.4882 247.016L147.375 145.18L146.96 144.461Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M149.011 145.785L-27.8701 247.59L-27.4551 248.309L149.426 146.503L149.011 145.785Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M151.32 146.943L-25.543 248.779L-25.1278 249.498L151.736 147.662L151.32 146.943Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M153.371 148.269L-23.5098 250.074L-23.0947 250.793L153.786 148.988L153.371 148.269Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M155.679 149.454L-21.2021 251.26L-20.7871 251.979L156.094 150.173L155.679 149.454Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M157.583 150.769L-19.2979 252.574L-18.8828 253.293L157.998 151.488L157.583 150.769Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M159.85 151.951L-17.0137 253.787L-16.5985 254.506L160.265 152.67L159.85 151.951Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M161.902 153.261L-14.9795 255.066L-14.5645 255.785L162.317 153.98L161.902 153.261Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M164.219 154.42L-12.6445 256.256L-12.2294 256.975L164.634 155.139L164.219 154.42Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M166.27 155.732L-10.6113 257.537L-10.1963 258.256L166.685 156.451L166.27 155.732Z",
    fill: "#222222"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M6.20864 244.233C5.3287 242.459 4.83984 240.197 4.83984 237.464V67.6291C4.83984 58.436 10.4291 47.7624 17.3383 43.7923L81.8347 6.5972C84.7515 4.92131 87.4239 4.70979 89.5586 5.71858C93.2739 7.02024 96.5655 10.1931 96.5655 10.1931L94.219 13.7889C94.3005 14.5048 94.3494 15.237 94.3494 16.0343V185.869C94.3494 195.062 88.7601 205.736 81.851 209.706L17.3383 246.901L15.1058 251.278C15.1058 251.278 9.56545 250.253 6.45307 244.737C6.43677 244.704 6.42048 244.672 6.40418 244.656C6.339 244.542 6.27382 244.412 6.22494 244.298C6.22494 244.298 6.22494 244.265 6.20864 244.265V244.233Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M15.4968 252.075L14.9753 251.978C14.7309 251.929 9.07648 250.823 5.83374 245.079L5.78485 244.981C5.73596 244.9 5.68708 244.802 5.63819 244.689L5.57301 244.575L6.20852 244.233L5.55672 244.558C4.5953 242.606 4.10645 240.23 4.10645 237.481V67.6294C4.10645 58.2249 9.87495 47.2583 16.9634 43.1581L81.4761 5.97924C84.4581 4.25453 87.326 3.92911 89.754 5.01926H89.8029C93.616 6.36974 96.9239 9.54255 97.0706 9.67271L97.4942 10.0795L94.9359 13.9682C95.0174 14.7167 95.05 15.3675 95.05 16.0183V185.853C95.05 195.258 89.2815 206.224 82.193 210.308L17.8596 247.389L15.4805 252.043L15.4968 252.075ZM6.87663 243.956L6.92551 244.054C6.92551 244.054 7.00699 244.217 7.03958 244.282C9.45127 248.545 13.3295 250.025 14.7146 250.416L16.7841 246.364L16.9634 246.251L81.4761 209.055C88.1734 205.199 93.616 194.786 93.616 185.837V16.0346C93.616 15.3512 93.5671 14.6679 93.4856 13.8706L93.3716 12.8455L93.893 12.9757L95.6366 10.3235C94.6752 9.47746 92.2798 7.52496 89.6562 6.51617H89.6237L89.2652 6.38601C87.2608 5.4423 84.8166 5.73517 82.2093 7.23209L17.6966 44.4272C10.9993 48.2834 5.55672 58.6967 5.55672 67.6457V237.481C5.55672 240.019 5.99669 242.183 6.86033 243.924V243.956H6.87663Z",
    fill: "#222222"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M22.7972 250.368L87.3099 213.173C94.2191 209.186 99.8084 198.513 99.8084 189.336V19.5011C99.8084 10.3081 94.2191 6.09396 87.3099 10.064L22.7972 47.2591C15.8881 51.2455 10.2988 61.9192 10.2988 71.0959V240.931C10.2988 250.124 15.8881 254.338 22.7972 250.368Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M17.8274 252.58C16.5401 252.58 15.3342 252.271 14.2588 251.653C11.2767 249.944 9.58203 246.039 9.58203 240.947V71.0956C9.58203 61.6911 15.3505 50.7245 22.4389 46.6243L86.9516 9.44544C90.1944 7.5743 93.3557 7.34651 95.8488 8.79461C98.8145 10.503 100.526 14.408 100.526 19.5008V189.336C100.526 198.74 94.757 209.707 87.6686 213.791L23.1559 250.986C21.3146 252.043 19.5058 252.58 17.8274 252.58ZM92.2802 9.29901C90.8462 9.29901 89.2819 9.77086 87.6686 10.6983L23.1559 47.8934C16.4586 51.7496 11.016 62.1629 11.016 71.1119V240.947C11.016 245.519 12.4663 248.968 14.9757 250.416C17.0126 251.588 19.6525 251.36 22.4389 249.766L86.9516 212.57C93.649 208.714 99.0916 198.301 99.0916 189.352V19.5008C99.0916 14.9287 97.6413 11.4793 95.1318 10.0312C94.2845 9.54307 93.3231 9.29901 92.2802 9.29901Z",
    fill: "#222222"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M26.708 50.3812L49.4886 37.3971C49.7983 37.2181 50.173 37.4459 50.173 37.7876V39.2357C50.173 41.6112 52.764 43.0756 54.8009 41.8553L56.1534 41.0417C58.4184 39.675 59.8198 37.2344 59.8198 34.5822V32.1579C59.8198 31.5721 60.1294 31.0352 60.6509 30.7423L88.7112 14.6342C92.1821 12.6329 95.0337 14.2762 95.0337 18.2789V189.985C95.0337 197.339 89.8193 206.37 83.4315 210.047L21.4446 245.778C17.9737 247.779 15.1221 246.135 15.1221 242.133V70.4431C15.1221 63.0887 20.3365 54.0584 26.7243 50.3812H26.708Z",
    fill: "url(#paint0_linear_600_71030)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M18.6088 247.356C17.8755 247.356 17.2074 247.177 16.5882 246.836C15.1542 246.006 14.3721 244.346 14.3721 242.133V70.4435C14.3721 62.845 19.7332 53.5544 26.3327 49.747L49.1134 36.7466C49.4882 36.5351 49.9282 36.5351 50.2867 36.7466C50.6615 36.9581 50.8733 37.3324 50.8733 37.7717V39.2198C50.8733 40.0659 51.3133 40.8306 52.0629 41.2536C52.8124 41.6767 53.6924 41.6604 54.4257 41.2211L55.7782 40.4076C57.8151 39.1872 59.0861 36.9419 59.0861 34.5663V32.142C59.0861 31.2959 59.5424 30.5149 60.2757 30.0919L88.336 13.9837C90.2425 12.8773 92.0839 12.7309 93.5179 13.5444C94.9518 14.3742 95.734 16.0339 95.734 18.2467V189.953C95.734 197.551 90.3729 206.842 83.7733 210.633L21.7864 246.364C20.6783 246.998 19.6028 247.324 18.6251 247.324L18.6088 247.356ZM27.066 50.9999C20.8739 54.5794 15.8223 63.3006 15.8223 70.4435V242.15C15.8223 243.825 16.3601 245.046 17.3215 245.599C18.2829 246.152 19.6191 246.006 21.0694 245.16L83.0563 209.429C89.2485 205.849 94.3 197.128 94.3 189.985V18.2792C94.3 16.6033 93.7623 15.383 92.8009 14.8298C91.8394 14.2766 90.5033 14.4231 89.0693 15.2691L61.0089 31.3773C60.7156 31.54 60.5527 31.8491 60.5527 32.1745V34.5989C60.5527 37.4788 59.0209 40.1798 56.544 41.6604L55.1915 42.474C54.002 43.1736 52.5843 43.2061 51.3785 42.5228C50.1726 41.8394 49.4556 40.6191 49.4556 39.2361V38.2435L27.0823 51.0161L27.066 50.9999Z",
    fill: "#222222"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M53.4648 38.228C53.4648 39.2368 54.1818 39.6435 55.0618 39.1391C55.9417 38.6347 56.6587 37.3982 56.6587 36.3894C56.6587 35.3806 55.9417 34.9738 55.0618 35.4782C54.1818 35.9826 53.4648 37.2192 53.4648 38.228Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M8.4568 54.5212L8.04883 55.2441L12.9183 57.9838L13.3262 57.2609L8.4568 54.5212Z",
    fill: "url(#paint1_linear_600_71030)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M87.636 9.83607C87.636 9.83607 85.6317 7.68832 82.666 7.00495L82.8453 6.19141C86.0554 6.92359 88.1575 9.16897 88.239 9.26659L87.6197 9.83607H87.636Z",
    fill: "url(#paint2_linear_600_71030)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M85.0443 11.3165C85.0443 11.3165 83.0399 9.16879 80.0742 8.48542L80.2535 7.67188C83.4636 8.40406 85.5494 10.6494 85.6472 10.7471L85.028 11.3165H85.0443Z",
    fill: "url(#paint3_linear_600_71030)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M5.93189 61.243L5.5625 61.9863L10.5693 64.4669L10.9387 63.7236L5.93189 61.243Z",
    fill: "url(#paint4_linear_600_71030)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M9.66357 232.761C9.53321 232.696 6.37194 231.036 4.54688 229.344L5.1172 228.742C6.86079 230.369 10.0221 232.013 10.0547 232.029L9.66357 232.761Z",
    fill: "url(#paint5_linear_600_71030)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M9.66357 240.751C9.53321 240.686 6.37194 239.027 4.54688 237.334L5.1172 236.732C6.86079 238.36 10.0221 240.003 10.0547 240.035L9.66357 240.768V240.751Z",
    fill: "url(#paint6_linear_600_71030)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M9.66357 244.021C9.53321 243.956 6.37194 242.296 4.54688 240.604L5.1172 240.002C6.86079 241.629 10.0221 243.272 10.0547 243.289L9.66357 244.021Z",
    fill: "url(#paint7_linear_600_71030)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M8.21332 142.931C7.96889 142.931 7.70816 142.849 7.44744 142.703L7.2356 142.589C6.33937 142.068 5.63867 140.751 5.63867 139.579V128.059C5.63867 127.376 5.8831 126.823 6.32307 126.579C6.71416 126.351 7.18672 126.383 7.64298 126.66L7.85482 126.774C8.75106 127.295 9.45175 128.612 9.45175 129.784V141.304C9.45175 141.987 9.20732 142.54 8.76735 142.784C8.5881 142.882 8.40886 142.931 8.19702 142.931H8.21332ZM7.65928 141.873L7.87112 141.987C7.98518 142.052 8.21331 142.15 8.35997 142.068C8.52292 141.971 8.63699 141.678 8.63699 141.304V129.784C8.63699 128.905 8.09925 127.864 7.44744 127.49L7.2356 127.376C7.12154 127.311 6.8934 127.213 6.74675 127.295C6.58379 127.392 6.46973 127.685 6.46973 128.059V139.579C6.46973 140.458 7.00747 141.499 7.65928 141.873Z",
    fill: "url(#paint8_linear_600_71030)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M8.21332 124.463C7.96889 124.463 7.70816 124.382 7.44744 124.236L7.2356 124.122C6.33937 123.601 5.63867 122.283 5.63867 121.112V109.592C5.63867 108.909 5.8831 108.355 6.32307 108.111C6.71416 107.884 7.18672 107.916 7.64298 108.176L7.85482 108.29C8.75106 108.811 9.45175 110.129 9.45175 111.3V122.82C9.45175 123.504 9.20732 124.057 8.76735 124.301C8.5881 124.398 8.40886 124.447 8.19702 124.447L8.21332 124.463ZM7.65928 123.406L7.87112 123.52C7.98518 123.585 8.19702 123.682 8.35997 123.601C8.52292 123.504 8.63699 123.211 8.63699 122.836V111.317C8.63699 110.438 8.09925 109.397 7.44744 109.022L7.2356 108.909C7.12154 108.843 6.8934 108.746 6.74675 108.843C6.58379 108.941 6.46973 109.234 6.46973 109.608V121.128C6.46973 122.007 7.00747 123.048 7.65928 123.422V123.406Z",
    fill: "url(#paint9_linear_600_71030)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M8.21332 103.377C7.96889 103.377 7.70816 103.296 7.44744 103.149L7.2356 103.035C6.33937 102.515 5.63867 101.197 5.63867 100.025V93.5495C5.63867 92.8661 5.8831 92.3129 6.32307 92.0688C6.71416 91.8411 7.18672 91.8736 7.64298 92.1502L7.85482 92.2641C8.75106 92.7848 9.45175 94.1027 9.45175 95.2742V101.75C9.45175 102.433 9.20732 102.987 8.76735 103.231C8.5881 103.328 8.40886 103.377 8.19702 103.377H8.21332ZM7.65928 102.319L7.87112 102.433C7.98518 102.498 8.19702 102.596 8.35997 102.515C8.52292 102.417 8.63699 102.124 8.63699 101.75V95.2742C8.63699 94.3956 8.09925 93.3542 7.44744 92.98L7.2356 92.8661C7.12154 92.801 6.8934 92.7034 6.74675 92.7848C6.58379 92.8824 6.46973 93.1753 6.46973 93.5495V100.025C6.46973 100.904 7.00747 101.945 7.65928 102.319Z",
    fill: "url(#paint10_linear_600_71030)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M7.44759 97.6499L7.65943 97.7638C8.42531 98.2031 9.04452 97.7312 9.04452 96.7062V95.2743C9.04452 94.2493 8.42531 93.0615 7.65943 92.6222L7.44759 92.5083C6.68172 92.069 6.0625 92.5408 6.0625 93.5496V94.9814C6.0625 96.0065 6.68172 97.1943 7.44759 97.6336V97.6499Z",
    fill: "url(#paint11_linear_600_71030)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M8.21332 98.3487C7.96889 98.3487 7.70816 98.2674 7.44744 98.1209L7.2356 98.0071C6.33937 97.4864 5.63867 96.1685 5.63867 94.997V93.5651C5.63867 92.8817 5.8831 92.3285 6.32307 92.0845C6.71416 91.8567 7.18672 91.8892 7.64298 92.1658L7.85482 92.2797C8.75106 92.8004 9.45175 94.1183 9.45175 95.2898V96.7217C9.45175 97.405 9.20732 97.9582 8.76735 98.2023C8.5881 98.2999 8.40886 98.3487 8.19702 98.3487H8.21332ZM7.65928 97.2911L7.87112 97.405C7.98518 97.4701 8.21331 97.5677 8.35997 97.4864C8.52292 97.3888 8.63699 97.0959 8.63699 96.7217V95.2898C8.63699 94.4112 8.09925 93.3699 7.44744 92.9956L7.2356 92.8817C7.12154 92.8167 6.8934 92.719 6.74675 92.8004C6.58379 92.898 6.46973 93.1909 6.46973 93.5651V94.997C6.46973 95.8756 7.00747 96.9169 7.65928 97.2911Z",
    fill: "url(#paint12_linear_600_71030)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M9.90513 51.7183L9.48047 52.4316L14.453 55.3832L14.8777 54.6699L9.90513 51.7183Z",
    fill: "url(#paint13_linear_600_71030)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M75.8705 5.23025L75.2188 3.94485L79.3251 1.84591C82.0464 0.462894 85.0447 -0.171668 87.9779 0.0398529L87.8801 1.47169C85.2077 1.29271 82.4538 1.86219 79.9769 3.13131L75.8705 5.23025Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M104.86 35.7212H103.426V16.2613C103.426 13.5766 102.693 11.0384 101.275 8.92318C99.1076 5.65275 95.9137 3.3911 91.791 2.20333L92.1821 0.820312C96.5818 2.08944 100.134 4.61141 102.464 8.12591C104.029 10.4852 104.843 13.2838 104.843 16.2613V35.7212H104.86Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M104.86 39.5625H103.426V50.8545H104.86V39.5625Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M1.43398 200.496H0V238.131H1.43398V200.496Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M1.43398 184.209H0V196.428H1.43398V184.209Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M21.2165 80.4019C21.0046 81.9639 19.5381 83.5096 19.2773 83.77V83.8025C19.5381 83.77 21.0046 83.6073 21.2165 84.9415C21.2165 84.9577 21.2491 84.9415 21.2491 84.9252C21.4609 83.3632 22.9438 81.8175 23.2045 81.5409V81.5083C22.9438 81.5409 21.4609 81.7036 21.2491 80.3856C21.2491 80.3694 21.2165 80.3856 21.2165 80.4019Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M26.8542 77.148C26.6423 78.71 25.1758 80.2557 24.915 80.5161V80.5486C25.1758 80.5161 26.6423 80.3534 26.8542 81.6876C26.8542 81.7038 26.8868 81.6876 26.8868 81.6713C27.0986 80.1093 28.5815 78.5636 28.8422 78.287V78.2544C28.5815 78.287 27.0986 78.4497 26.8868 77.1317C26.8868 77.1155 26.8542 77.1317 26.8542 77.148Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M32.4928 73.9097C32.281 75.4717 30.8144 77.0175 30.5537 77.2778V77.3103C30.8144 77.2778 32.281 77.1151 32.4928 78.4493C32.4928 78.4656 32.5254 78.4493 32.5254 78.433C32.7373 76.871 34.2201 75.3253 34.4809 75.0487V75.0161C34.2201 75.0487 32.7373 75.2114 32.5254 73.8935C32.5254 73.8772 32.4928 73.8935 32.4928 73.9097Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M38.1305 70.6558C37.9187 72.2178 36.4521 73.7636 36.1914 74.0239V74.0564C36.4521 74.0239 37.9187 73.8612 38.1305 75.1954C38.1305 75.2117 38.1631 75.1954 38.1631 75.1791C38.375 73.6171 39.8578 72.0714 40.1185 71.7948V71.7622C39.8578 71.7948 38.375 71.9575 38.1631 70.6396C38.1631 70.6233 38.1305 70.6395 38.1305 70.6558Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M43.7526 67.4019C43.5408 68.9639 42.0742 70.5096 41.8135 70.77V70.8025C42.0742 70.77 43.5408 70.6073 43.7526 71.9415C43.7526 71.9577 43.7852 71.9415 43.7852 71.9252C43.997 70.3632 45.4799 68.8175 45.7406 68.5409V68.5083C45.4799 68.5409 43.997 68.7036 43.7852 67.3856C43.7852 67.3694 43.7526 67.3856 43.7526 67.4019Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M49.3913 64.1623C49.1794 65.7243 47.7129 67.2701 47.4521 67.5304V67.5629C47.7129 67.5304 49.1794 67.3677 49.3913 68.6856C49.3913 68.7019 49.4239 68.6856 49.4239 68.6693C49.6357 67.1073 51.1186 65.5616 51.3793 65.285V65.2525C51.1186 65.285 49.6357 65.4477 49.4239 64.1298C49.4239 64.1135 49.3913 64.1298 49.3913 64.1461V64.1623Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M55.029 60.9097C54.8171 62.4717 53.3506 64.0175 53.0898 64.2778V64.3103C53.3506 64.2778 54.8171 64.1151 55.029 65.4493C55.029 65.4656 55.0616 65.4493 55.0616 65.433C55.2734 63.871 56.7563 62.3253 57.017 62.0487V62.0161C56.7563 62.0487 55.2734 62.2114 55.0616 60.8935C55.0616 60.8772 55.029 60.8935 55.029 60.9097Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M60.6667 57.6558C60.4548 59.2178 58.9883 60.7636 58.7275 61.0239V61.0564C58.9883 61.0239 60.4548 60.8612 60.6667 62.1954C60.6667 62.2117 60.6993 62.1954 60.6993 62.1791C60.9111 60.6171 62.394 59.0714 62.6547 58.7948V58.7622C62.394 58.7948 60.9111 58.9575 60.6993 57.6396C60.6993 57.6233 60.6667 57.6396 60.6667 57.6558Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M66.3053 54.4175C66.0935 55.9795 64.6269 57.5253 64.3662 57.7856V57.8181C64.6269 57.7856 66.0935 57.6229 66.3053 58.9571C66.3053 58.9734 66.3379 58.9571 66.3379 58.9408C66.5498 57.3788 68.0326 55.8331 68.2934 55.5565V55.524C68.0326 55.5565 66.5498 55.7192 66.3379 54.4013C66.3379 54.385 66.3053 54.4013 66.3053 54.4175Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M21.2165 73.8765C21.0046 75.4385 19.5381 76.9843 19.2773 77.2446V77.2771C19.5381 77.2446 21.0046 77.0819 21.2165 78.4161C21.2165 78.4324 21.2491 78.4161 21.2491 78.3998C21.4609 76.8378 22.9438 75.2921 23.2045 75.0155V74.9829C22.9438 75.0155 21.4609 75.1782 21.2491 73.8603C21.2491 73.844 21.2165 73.8603 21.2165 73.8765Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M26.8542 70.6226C26.6423 72.1846 25.1758 73.7303 24.915 73.9907V74.0232C25.1758 73.9907 26.6423 73.828 26.8542 75.1622C26.8542 75.1784 26.8868 75.1622 26.8868 75.1459C27.0986 73.5839 28.5815 72.0382 28.8422 71.7616V71.729C28.5815 71.7616 27.0986 71.9243 26.8868 70.6063C26.8868 70.5901 26.8542 70.6064 26.8542 70.6226Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M32.4928 67.3843C32.281 68.9463 30.8144 70.4921 30.5537 70.7524V70.7849C30.8144 70.7524 32.281 70.5897 32.4928 71.9239C32.4928 71.9402 32.5254 71.9239 32.5254 71.9076C32.7373 70.3456 34.2201 68.7999 34.4809 68.5233V68.4908C34.2201 68.5233 32.7373 68.686 32.5254 67.3681C32.5254 67.3518 32.4928 67.3681 32.4928 67.3843Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M38.1305 64.1311C37.9187 65.6931 36.4521 67.2388 36.1914 67.4991V67.5317C36.4521 67.4991 37.9187 67.3364 38.1305 68.6544C38.1305 68.6706 38.1631 68.6544 38.1631 68.6381C38.375 67.0761 39.8578 65.5304 40.1185 65.2538V65.2212C39.8578 65.2538 38.375 65.4165 38.1631 64.0985C38.1631 64.0823 38.1305 64.0985 38.1305 64.1148V64.1311Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M43.7526 60.8765C43.5408 62.4385 42.0742 63.9843 41.8135 64.2446V64.2771C42.0742 64.2446 43.5408 64.0819 43.7526 65.4161C43.7526 65.4324 43.7852 65.4161 43.7852 65.3998C43.997 63.8378 45.4799 62.2921 45.7406 62.0155V61.9829C45.4799 62.0155 43.997 62.1782 43.7852 60.8603C43.7852 60.844 43.7526 60.8603 43.7526 60.8765Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M49.3913 57.6382C49.1794 59.2002 47.7129 60.746 47.4521 61.0063V61.0388C47.7129 61.0063 49.1794 60.8436 49.3913 62.1778C49.3913 62.1941 49.4239 62.1778 49.4239 62.1615C49.6357 60.5995 51.1186 59.0538 51.3793 58.7772V58.7447C51.1186 58.7772 49.6357 58.9399 49.4239 57.622C49.4239 57.6057 49.3913 57.622 49.3913 57.6382Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M55.029 54.3843C54.8171 55.9463 53.3506 57.4921 53.0898 57.7524V57.7849C53.3506 57.7524 54.8171 57.5897 55.029 58.9239C55.029 58.9402 55.0616 58.9239 55.0616 58.9076C55.2734 57.3456 56.7563 55.7999 57.017 55.5233V55.4908C56.7563 55.5233 55.2734 55.686 55.0616 54.3681C55.0616 54.3518 55.029 54.3681 55.029 54.3843Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M60.6667 51.1304C60.4548 52.6924 58.9883 54.2382 58.7275 54.4985V54.531C58.9883 54.4985 60.4548 54.3358 60.6667 55.67C60.6667 55.6863 60.6993 55.67 60.6993 55.6537C60.9111 54.0917 62.394 52.546 62.6547 52.2694V52.2368C62.394 52.2694 60.9111 52.4321 60.6993 51.1142C60.6993 51.0979 60.6667 51.1142 60.6667 51.1304Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M66.3053 47.8922C66.0935 49.4542 64.6269 50.9999 64.3662 51.2602V51.2928C64.6269 51.2602 66.0935 51.0975 66.3053 52.4317C66.3053 52.448 66.3379 52.4317 66.3379 52.4154C66.5498 50.8534 68.0326 49.3077 68.2934 49.0311V48.9986C68.0326 49.0311 66.5498 49.1938 66.3379 47.8759C66.3379 47.8596 66.3053 47.8759 66.3053 47.8922Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M21.2165 67.3531C21.0046 68.9151 19.5381 70.4608 19.2773 70.7211V70.7537C19.5381 70.7211 21.0046 70.5584 21.2165 71.8926C21.2165 71.9089 21.2491 71.8926 21.2491 71.8764C21.4609 70.3144 22.9438 68.7686 23.2045 68.492V68.4595C22.9438 68.492 21.4609 68.6548 21.2491 67.3368C21.2491 67.3205 21.2165 67.3368 21.2165 67.3531Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M26.8542 64.0979C26.6423 65.6599 25.1758 67.2056 24.915 67.4659V67.4985C25.1758 67.4659 26.6423 67.3032 26.8542 68.6212C26.8542 68.6374 26.8868 68.6212 26.8868 68.6049C27.0986 67.0429 28.5815 65.4972 28.8422 65.2206V65.188C28.5815 65.2206 27.0986 65.3833 26.8868 64.0653C26.8868 64.0491 26.8542 64.0653 26.8542 64.0816V64.0979Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M32.4928 60.8609C32.281 62.4229 30.8144 63.9686 30.5537 64.229V64.2615C30.8144 64.229 32.281 64.0663 32.4928 65.4005C32.4928 65.4167 32.5254 65.4005 32.5254 65.3842C32.7373 63.8222 34.2201 62.2765 34.4809 61.9999V61.9673C34.2201 61.9999 32.7373 62.1626 32.5254 60.8446C32.5254 60.8284 32.4928 60.8446 32.4928 60.8609Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M38.1305 57.607C37.9187 59.169 36.4521 60.7147 36.1914 60.9751V61.0076C36.4521 60.9751 37.9187 60.8123 38.1305 62.1466C38.1305 62.1628 38.1631 62.1466 38.1631 62.1303C38.375 60.5683 39.8578 59.0226 40.1185 58.746V58.7134C39.8578 58.746 38.375 58.9087 38.1631 57.5907C38.1631 57.5745 38.1305 57.5907 38.1305 57.607Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M43.7526 54.3511C43.5408 55.9131 42.0742 57.4589 41.8135 57.7192V57.7517C42.0742 57.7192 43.5408 57.5565 43.7526 58.8907C43.7526 58.907 43.7852 58.8907 43.7852 58.8744C43.997 57.3124 45.4799 55.7667 45.7406 55.4901V55.4576C45.4799 55.4901 43.997 55.6528 43.7852 54.3349C43.7852 54.3186 43.7526 54.3349 43.7526 54.3511Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    d: "M49.3913 51.1148C49.1794 52.6768 47.7129 54.2225 47.4521 54.4829V54.5154C47.7129 54.4829 49.1794 54.3202 49.3913 55.6544C49.3913 55.6706 49.4239 55.6544 49.4239 55.6381C49.6357 54.0761 51.1186 52.5304 51.3793 52.2538V52.2212C51.1186 52.2538 49.6357 52.4165 49.4239 51.0985C49.4239 51.0823 49.3913 51.0985 49.3913 51.1148Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M55.029 47.8589C54.8171 49.4209 53.3506 50.9667 53.0898 51.227V51.2596C53.3506 51.227 54.8171 51.0643 55.029 52.3985C55.029 52.4148 55.0616 52.3985 55.0616 52.3822C55.2734 50.8202 56.7563 49.2745 57.017 48.9979V48.9654C56.7563 48.9979 55.2734 49.1606 55.0616 47.8427C55.0616 47.8264 55.029 47.8427 55.029 47.8589Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    d: "M60.6667 44.605C60.4548 46.167 58.9883 47.7128 58.7275 47.9731V48.0056C58.9883 47.9731 60.4548 47.8104 60.6667 49.1446C60.6667 49.1609 60.6993 49.1446 60.6993 49.1283C60.9111 47.5663 62.394 46.0206 62.6547 45.744V45.7115C62.394 45.744 60.9111 45.9067 60.6993 44.5888C60.6993 44.5725 60.6667 44.5888 60.6667 44.605Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M66.3053 41.3687C66.0935 42.9307 64.6269 44.4764 64.3662 44.7368V44.7693C64.6269 44.7368 66.0935 44.5741 66.3053 45.9083C66.3053 45.9245 66.3379 45.9083 66.3379 45.892C66.5498 44.33 68.0326 42.7843 68.2934 42.5077V42.4751C68.0326 42.5077 66.5498 42.6704 66.3379 41.3524C66.3379 41.3362 66.3053 41.3524 66.3053 41.3687Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M71.943 51.1623C71.7312 52.7243 70.2646 54.2701 70.0039 54.5304V54.5629C70.2646 54.5304 71.7312 54.3677 71.943 55.6856C71.943 55.7019 71.9756 55.6856 71.9756 55.6693C72.1875 54.1073 73.6703 52.5616 73.9311 52.285V52.2525C73.6703 52.285 72.1875 52.4477 71.9756 51.1298C71.9756 51.1135 71.943 51.1298 71.943 51.1461V51.1623Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M77.5651 47.9084C77.3533 49.4704 75.8867 51.0161 75.626 51.2765V51.309C75.8867 51.2765 77.3533 51.1138 77.5651 52.4317C77.5651 52.448 77.5977 52.4317 77.5977 52.4154C77.8095 50.8534 79.2924 49.3077 79.5531 49.0311V48.9986C79.2924 49.0311 77.8095 49.1938 77.5977 47.8759C77.5977 47.8596 77.5651 47.8759 77.5651 47.8922V47.9084Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M83.2038 44.6714C82.9919 46.2334 81.5254 47.7792 81.2646 48.0395V48.0721C81.5254 48.0395 82.9919 47.8768 83.2038 49.211C83.2038 49.2273 83.2364 49.211 83.2364 49.1947C83.4482 47.6327 84.9311 46.087 85.1918 45.8104V45.7779C84.9311 45.8104 83.4482 45.9731 83.2364 44.6552C83.2364 44.6389 83.2038 44.6552 83.2038 44.6714Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M88.8415 41.4175C88.6296 42.9795 87.1631 44.5253 86.9023 44.7856V44.8181C87.1631 44.7856 88.6296 44.6229 88.8415 45.9571C88.8415 45.9734 88.8741 45.9571 88.8741 45.9408C89.0859 44.3788 90.5688 42.8331 90.8295 42.5565V42.524C90.5688 42.5565 89.0859 42.7192 88.8741 41.4013C88.8741 41.385 88.8415 41.4013 88.8415 41.4175Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M71.943 44.6389C71.7312 46.2009 70.2646 47.7466 70.0039 48.007V48.0395C70.2646 48.007 71.7312 47.8442 71.943 49.1622C71.943 49.1784 71.9756 49.1622 71.9756 49.1459C72.1875 47.5839 73.6703 46.0382 73.9311 45.7616V45.729C73.6703 45.7616 72.1875 45.9243 71.9756 44.6063C71.9756 44.5901 71.943 44.6063 71.943 44.6226V44.6389Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M77.5651 41.3843C77.3533 42.9463 75.8867 44.4921 75.626 44.7524V44.7849C75.8867 44.7524 77.3533 44.5897 77.5651 45.9239C77.5651 45.9402 77.5977 45.9239 77.5977 45.9076C77.8095 44.3456 79.2924 42.7999 79.5531 42.5233V42.4908C79.2924 42.5233 77.8095 42.686 77.5977 41.3681C77.5977 41.3518 77.5651 41.3681 77.5651 41.3843Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    d: "M83.2038 38.1461C82.9919 39.7081 81.5254 41.2538 81.2646 41.5141V41.5467C81.5254 41.5141 82.9919 41.3514 83.2038 42.6856C83.2038 42.7019 83.2364 42.6856 83.2364 42.6693C83.4482 41.1073 84.9311 39.5616 85.1918 39.285V39.2525C84.9311 39.285 83.4482 39.4477 83.2364 38.1298C83.2364 38.1135 83.2038 38.1298 83.2038 38.1461Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M88.8415 34.8922C88.6296 36.4542 87.1631 37.9999 86.9023 38.2602V38.2928C87.1631 38.2602 88.6296 38.0975 88.8415 39.4317C88.8415 39.448 88.8741 39.4317 88.8741 39.4154C89.0859 37.8534 90.5688 36.3077 90.8295 36.0311V35.9986C90.5688 36.0311 89.0859 36.1938 88.8741 34.8759C88.8741 34.8596 88.8415 34.8759 88.8415 34.8922Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M71.943 38.1129C71.7312 39.6749 70.2646 41.2206 70.0039 41.4809V41.5135C70.2646 41.4809 71.7312 41.3182 71.943 42.6524C71.943 42.6687 71.9756 42.6524 71.9756 42.6361C72.1875 41.0741 73.6703 39.5284 73.9311 39.2518V39.2193C73.6703 39.2518 72.1875 39.4145 71.9756 38.0966C71.9756 38.0803 71.943 38.0966 71.943 38.1129Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M77.5651 34.8589C77.3533 36.4209 75.8867 37.9667 75.626 38.227V38.2596C75.8867 38.227 77.3533 38.0643 77.5651 39.3985C77.5651 39.4148 77.5977 39.3985 77.5977 39.3822C77.8095 37.8202 79.2924 36.2745 79.5531 35.9979V35.9654C79.2924 35.9979 77.8095 36.1606 77.5977 34.8427C77.5977 34.8264 77.5651 34.8427 77.5651 34.8589Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    d: "M83.2038 31.6207C82.9919 33.1827 81.5254 34.7284 81.2646 34.9887V35.0213C81.5254 34.9887 82.9919 34.826 83.2038 36.1602C83.2038 36.1765 83.2364 36.1602 83.2364 36.144C83.4482 34.582 84.9311 33.0362 85.1918 32.7596V32.7271C84.9311 32.7596 83.4482 32.9223 83.2364 31.6044C83.2364 31.5881 83.2038 31.6044 83.2038 31.6207Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    d: "M88.8415 28.3674C88.6296 29.9294 87.1631 31.4751 86.9023 31.7355V31.768C87.1631 31.7355 88.6296 31.5728 88.8415 32.8907C88.8415 32.907 88.8741 32.8907 88.8741 32.8744C89.0859 31.3124 90.5688 29.7667 90.8295 29.4901V29.4576C90.5688 29.4901 89.0859 29.6528 88.8741 28.3349C88.8741 28.3186 88.8415 28.3349 88.8415 28.3511V28.3674Z",
    fill: "#222222"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    d: "M26.8542 230.127C26.6423 231.689 25.1758 233.234 24.915 233.495V233.527C25.1758 233.495 26.6423 233.332 26.8542 234.666C26.8542 234.682 26.8868 234.666 26.8868 234.65C27.0986 233.088 28.5815 231.542 28.8422 231.265V231.233C28.5815 231.265 27.0986 231.428 26.8868 230.11C26.8868 230.094 26.8542 230.11 26.8542 230.127Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    d: "M32.4928 226.888C32.281 228.45 30.8144 229.996 30.5537 230.256V230.289C30.8144 230.256 32.281 230.094 32.4928 231.428C32.4928 231.444 32.5254 231.428 32.5254 231.412C32.7373 229.85 34.2201 228.304 34.4809 228.027V227.995C34.2201 228.027 32.7373 228.19 32.5254 226.872C32.5254 226.856 32.4928 226.872 32.4928 226.888Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_101",
    d: "M38.1305 223.634C37.9187 225.196 36.4521 226.742 36.1914 227.002V227.035C36.4521 227.002 37.9187 226.84 38.1305 228.174C38.1305 228.19 38.1631 228.174 38.1631 228.158C38.375 226.596 39.8578 225.05 40.1185 224.773V224.741C39.8578 224.773 38.375 224.936 38.1631 223.618C38.1631 223.602 38.1305 223.618 38.1305 223.634Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    d: "M43.7526 220.38C43.5408 221.942 42.0742 223.488 41.8135 223.748V223.781C42.0742 223.748 43.5408 223.586 43.7526 224.92C43.7526 224.936 43.7852 224.92 43.7852 224.904C43.997 223.342 45.4799 221.796 45.7406 221.519V221.487C45.4799 221.519 43.997 221.682 43.7852 220.364C43.7852 220.348 43.7526 220.364 43.7526 220.38Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    d: "M49.3913 217.143C49.1794 218.705 47.7129 220.251 47.4521 220.511V220.543C47.7129 220.511 49.1794 220.348 49.3913 221.666C49.3913 221.682 49.4239 221.666 49.4239 221.65C49.6357 220.088 51.1186 218.542 51.3793 218.265V218.233C51.1186 218.265 49.6357 218.428 49.4239 217.11C49.4239 217.094 49.3913 217.11 49.3913 217.127V217.143Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    d: "M60.6667 210.634C60.4548 212.196 58.9883 213.742 58.7275 214.002V214.035C58.9883 214.002 60.4548 213.84 60.6667 215.174C60.6667 215.19 60.6993 215.174 60.6993 215.158C60.9111 213.596 62.394 212.05 62.6547 211.773V211.741C62.394 211.773 60.9111 211.936 60.6993 210.618C60.6993 210.602 60.6667 210.618 60.6667 210.634Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_105",
    d: "M66.3053 207.396C66.0935 208.958 64.6269 210.504 64.3662 210.764V210.797C64.6269 210.764 66.0935 210.601 66.3053 211.936C66.3053 211.952 66.3379 211.936 66.3379 211.919C66.5498 210.357 68.0326 208.812 68.2934 208.535V208.502C68.0326 208.535 66.5498 208.698 66.3379 207.38C66.3379 207.364 66.3053 207.38 66.3053 207.396Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_106",
    d: "M21.2165 226.855C21.0046 228.417 19.5381 229.963 19.2773 230.223V230.256C19.5381 230.223 21.0046 230.06 21.2165 231.395C21.2165 231.411 21.2491 231.395 21.2491 231.378C21.4609 229.816 22.9438 228.271 23.2045 227.994V227.961C22.9438 227.994 21.4609 228.157 21.2491 226.839C21.2491 226.823 21.2165 226.839 21.2165 226.855Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_107",
    d: "M26.8542 223.601C26.6423 225.163 25.1758 226.709 24.915 226.969V227.002C25.1758 226.969 26.6423 226.806 26.8542 228.141C26.8542 228.157 26.8868 228.141 26.8868 228.124C27.0986 226.562 28.5815 225.017 28.8422 224.74V224.708C28.5815 224.74 27.0986 224.903 26.8868 223.585C26.8868 223.569 26.8542 223.585 26.8542 223.601Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_108",
    d: "M32.4928 220.363C32.281 221.925 30.8144 223.471 30.5537 223.732V223.764C30.8144 223.732 32.281 223.569 32.4928 224.887C32.4928 224.903 32.5254 224.887 32.5254 224.871C32.7373 223.309 34.2201 221.763 34.4809 221.486V221.454C34.2201 221.486 32.7373 221.649 32.5254 220.331C32.5254 220.315 32.4928 220.331 32.4928 220.347V220.363Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_109",
    d: "M38.1305 217.11C37.9187 218.672 36.4521 220.217 36.1914 220.478V220.51C36.4521 220.478 37.9187 220.315 38.1305 221.633C38.1305 221.649 38.1631 221.633 38.1631 221.617C38.375 220.055 39.8578 218.509 40.1185 218.232V218.2C39.8578 218.232 38.375 218.395 38.1631 217.077C38.1631 217.061 38.1305 217.077 38.1305 217.093V217.11Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_110",
    d: "M43.7526 213.856C43.5408 215.418 42.0742 216.963 41.8135 217.224V217.256C42.0742 217.224 43.5408 217.061 43.7526 218.379C43.7526 218.395 43.7852 218.379 43.7852 218.363C43.997 216.801 45.4799 215.255 45.7406 214.978V214.946C45.4799 214.978 43.997 215.141 43.7852 213.823C43.7852 213.807 43.7526 213.823 43.7526 213.839V213.856Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_111",
    d: "M49.3913 210.617C49.1794 212.179 47.7129 213.724 47.4521 213.985V214.017C47.7129 213.985 49.1794 213.822 49.3913 215.156C49.3913 215.173 49.4239 215.156 49.4239 215.14C49.6357 213.578 51.1186 212.032 51.3793 211.756V211.723C51.1186 211.756 49.6357 211.918 49.4239 210.6C49.4239 210.584 49.3913 210.601 49.3913 210.617Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_112",
    d: "M55.029 213.856C54.8171 215.418 53.3506 216.963 53.0898 217.224V217.256C53.3506 217.224 54.8171 217.061 55.029 218.379C55.029 218.395 55.0616 218.379 55.0616 218.363C55.2734 216.801 56.7563 215.255 57.017 214.978V214.946C56.7563 214.978 55.2734 215.141 55.0616 213.823C55.0616 213.807 55.029 213.823 55.029 213.839V213.856Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_113",
    d: "M55.029 207.33C54.8171 208.892 53.3506 210.437 53.0898 210.698V210.73C53.3506 210.698 54.8171 210.535 55.029 211.869C55.029 211.885 55.0616 211.869 55.0616 211.853C55.2734 210.291 56.7563 208.745 57.017 208.469V208.436C56.7563 208.469 55.2734 208.631 55.0616 207.313C55.0616 207.297 55.029 207.313 55.029 207.33Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_114",
    d: "M60.6667 204.109C60.4548 205.671 58.9883 207.217 58.7275 207.477V207.51C58.9883 207.477 60.4548 207.314 60.6667 208.648C60.6667 208.665 60.6993 208.649 60.6993 208.632C60.9111 207.07 62.394 205.525 62.6547 205.248V205.215C62.394 205.248 60.9111 205.411 60.6993 204.093C60.6993 204.076 60.6667 204.093 60.6667 204.109Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_115",
    d: "M66.3053 200.871C66.0935 202.433 64.6269 203.978 64.3662 204.239V204.271C64.6269 204.239 66.0935 204.076 66.3053 205.41C66.3053 205.426 66.3379 205.41 66.3379 205.394C66.5498 203.832 68.0326 202.286 68.2934 202.01V201.977C68.0326 202.01 66.5498 202.172 66.3379 200.854C66.3379 200.838 66.3053 200.854 66.3053 200.871Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_116",
    d: "M71.943 204.141C71.7312 205.703 70.2646 207.249 70.0039 207.509V207.541C70.2646 207.509 71.7312 207.346 71.943 208.664C71.943 208.68 71.9756 208.664 71.9756 208.648C72.1875 207.086 73.6703 205.54 73.9311 205.264V205.231C73.6703 205.264 72.1875 205.426 71.9756 204.108C71.9756 204.092 71.943 204.108 71.943 204.125V204.141Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_117",
    d: "M77.5651 200.888C77.3533 202.45 75.8867 203.996 75.626 204.256V204.289C75.8867 204.256 77.3533 204.094 77.5651 205.428C77.5651 205.444 77.5977 205.428 77.5977 205.412C77.8095 203.85 79.2924 202.304 79.5531 202.027V201.995C79.2924 202.027 77.8095 202.19 77.5977 200.872C77.5977 200.856 77.5651 200.872 77.5651 200.888Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_118",
    d: "M83.2038 197.65C82.9919 199.212 81.5254 200.758 81.2646 201.018V201.051C81.5254 201.018 82.9919 200.855 83.2038 202.19C83.2038 202.206 83.2364 202.19 83.2364 202.173C83.4482 200.611 84.9311 199.066 85.1918 198.789V198.756C84.9311 198.789 83.4482 198.952 83.2364 197.634C83.2364 197.617 83.2038 197.634 83.2038 197.65Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_119",
    d: "M71.943 197.617C71.7312 199.179 70.2646 200.725 70.0039 200.985V201.018C70.2646 200.985 71.7312 200.823 71.943 202.141C71.943 202.157 71.9756 202.141 71.9756 202.124C72.1875 200.562 73.6703 199.017 73.9311 198.74V198.708C73.6703 198.74 72.1875 198.903 71.9756 197.585C71.9756 197.569 71.943 197.585 71.943 197.601V197.617Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_120",
    d: "M77.5651 194.363C77.3533 195.925 75.8867 197.471 75.626 197.731V197.763C75.8867 197.731 77.3533 197.568 77.5651 198.902C77.5651 198.919 77.5977 198.902 77.5977 198.886C77.8095 197.324 79.2924 195.778 79.5531 195.502V195.469C79.2924 195.502 77.8095 195.665 77.5977 194.347C77.5977 194.33 77.5651 194.347 77.5651 194.363Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_121",
    d: "M83.2038 191.125C82.9919 192.687 81.5254 194.232 81.2646 194.493V194.525C81.5254 194.493 82.9919 194.33 83.2038 195.664C83.2038 195.68 83.2364 195.664 83.2364 195.648C83.4482 194.086 84.9311 192.54 85.1918 192.264V192.231C84.9311 192.264 83.4482 192.426 83.2364 191.108C83.2364 191.092 83.2038 191.108 83.2038 191.125Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_122",
    d: "M88.8415 187.871C88.6296 189.433 87.1631 190.978 86.9023 191.239V191.271C87.1631 191.239 88.6296 191.076 88.8415 192.41C88.8415 192.427 88.8741 192.41 88.8741 192.394C89.0859 190.832 90.5688 189.286 90.8295 189.01V188.977C90.5688 189.01 89.0859 189.172 88.8741 187.854C88.8741 187.838 88.8415 187.854 88.8415 187.871Z",
    fill: "#222222"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_600_71030",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 67,
    width: 66,
    height: 140
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_123",
    d: "M84.6864 172.267L25.4208 206.436C23.6446 207.461 22.1943 206.631 22.1943 204.581V107.851C22.1943 105.801 23.6446 103.295 25.4208 102.27L84.6864 68.1014C86.4626 67.0763 87.9129 67.9062 87.9129 69.9563V166.686C87.9129 168.736 86.4626 171.242 84.6864 172.267Z",
    fill: "white"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_600_71030)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_124",
    d: "M32.1347 205.59L29.9512 205.2L30.3423 203.02L32.5258 203.41L32.1347 205.59ZM32.9169 201.23L30.7333 200.839L31.1244 198.659L33.308 199.05L32.9169 201.23ZM33.6991 196.869L31.5155 196.479L31.9066 194.299L34.0901 194.689L33.6991 196.869ZM34.4812 192.509L32.2977 192.118L32.6888 189.938L34.8723 190.328L34.4812 192.509ZM35.2634 188.148L33.0798 187.758L33.4709 185.577L35.6545 185.968L35.2634 188.148ZM36.0456 183.788L33.862 183.397L34.2531 181.217L36.4367 181.607L36.0456 183.788ZM37.0722 179.736L35.019 178.906L35.85 176.856L37.9032 177.686L37.0722 179.736ZM38.7506 175.636L36.6974 174.79L37.5284 172.74L39.5816 173.586L38.7506 175.636ZM40.429 171.536L38.3758 170.706L39.2068 168.656L41.26 169.486L40.429 171.536ZM42.1074 167.435L40.0542 166.589L40.8853 164.539L42.9384 165.385L42.1074 167.435ZM43.7858 163.335L41.7326 162.489L42.5637 160.439L44.6169 161.269L43.7858 163.319V163.335ZM45.3175 159.853L43.965 158.096L45.7249 156.745L47.0774 158.503L45.3175 159.853ZM48.8373 157.169L47.4848 155.411L49.2447 154.061L50.5972 155.818L48.8373 157.169ZM52.3571 154.484L51.0046 152.727L52.7645 151.376L54.117 153.133L52.3571 154.484ZM55.8768 151.799L54.5243 150.042L56.2842 148.691L57.6367 150.449L55.8768 151.799ZM59.3151 149.261L58.2233 147.341L60.1462 146.251L61.238 148.171L59.3151 149.261ZM63.1771 147.081L62.0853 145.161L64.0081 144.07L65.0999 145.99L63.1771 147.081ZM67.039 144.9L65.9473 142.98L66.5502 142.639L67.642 144.559L67.039 144.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_125",
    d: "M65.1975 70.4766L36.7949 86.064L38.1148 112.227L39.6303 142.166L44.3396 153.263L53.7582 145.973L52.5524 136.894L59.3475 101.18L65.1975 70.4766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_126",
    d: "M44.1115 154.142L39.0763 142.199L36.2246 85.7558L65.9634 69.4199L53.1064 136.911L54.3449 146.218L44.0952 154.142H44.1115ZM40.1843 142.037L44.584 152.385L53.1879 145.73L52.0147 136.879L64.4642 71.5189L37.3979 86.3904L40.2006 142.053L40.1843 142.037Z",
    fill: "#222222"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_127",
    d: "M31.5155 120.867L29.9349 90.7988L8.3926 100.74L4.49805 153.263L16.1328 160.991L31.5155 120.867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_128",
    d: "M16.4096 161.838L3.91113 153.556V153.23L7.85457 100.366L30.4234 89.9531L32.0692 120.949L16.3933 161.821L16.4096 161.838ZM5.06809 152.986L15.8718 160.145L30.9612 120.77L29.4294 91.6453L8.93005 101.099L5.06809 152.986Z",
    fill: "#222222"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_129",
    d: "M31.7109 131.037L18.1533 166.329L33.2916 172.365L38.4083 160.26L32.9005 146.836L31.7109 131.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_130",
    d: "M33.6007 173.08L17.4521 166.637L32.1015 128.547L33.454 146.705L39.027 160.259L33.617 173.08H33.6007ZM18.8698 166.019L32.9978 171.648L37.8049 160.259L32.3297 146.884L31.3357 133.558L18.8535 166.019H18.8698Z",
    fill: "#222222"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_131",
    d: "M111.231 43.9395L70.9822 67.1416C70.8518 67.223 69.483 74.1056 67.7068 83.4125L85.6153 90.4577L89.2817 100.237V109.462L82.5843 94.5254L66.778 88.2612C66.6313 89.0422 66.4847 89.8395 66.3217 90.6367C66.3217 90.6367 66.3217 90.653 66.3217 90.6693C65.7025 93.8746 65.0833 97.2264 64.4478 100.578C61.6287 115.531 58.1904 133.803 58.1904 133.803L66.3217 136.341L82.2258 125.586L122.133 98.5932L111.231 43.9395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_132",
    d: "M66.4196 136.943L57.5713 134.177L63.8124 100.968L63.8938 100.464C64.5293 97.1122 65.1649 93.7767 65.7678 90.5551L66.3544 87.4962L82.9918 94.0858L88.7114 106.858V100.334L85.1754 90.8805L67.0714 83.7539L67.1529 83.2983C70.3141 66.8648 70.3793 66.8322 70.7052 66.6532L111.622 43.0605L122.752 98.8207L122.442 99.0322L66.4033 136.927L66.4196 136.943ZM58.8423 133.412L66.2403 135.723L121.53 98.3325L110.857 44.8015L71.4548 67.5156C71.2755 68.199 70.6075 71.2904 68.3424 83.0705L86.0553 90.0344L89.8358 100.236V112.049L82.177 94.9482L67.2017 89.0256L66.8758 90.7503C66.2892 93.8418 65.6863 97.0146 65.0834 100.204L65.0019 100.692L58.8423 133.429V133.412Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_133",
    d: "M57.6523 196.021L58.1901 178.481L60.6181 173.828L98.977 153.115L95.0824 176.008L59.95 196.249L57.6523 196.021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_134",
    d: "M60.0641 196.819L57.082 196.51L57.7013 178.221L60.1944 173.422L60.3411 173.34L99.7103 152.074L95.5713 176.334L60.0641 196.803V196.819ZM58.2227 195.517L59.8196 195.68L94.5773 175.651L98.2437 154.141L61.0255 174.235L58.7441 178.628L58.2227 195.517Z",
    fill: "#222222"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_135",
    d: "M72.7422 161.285L94.4148 149.229V133.869L72.7422 146.365V161.285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_136",
    d: "M73.0026 161.773L72.4648 160.796L93.8604 148.902V134.828L73.0189 146.836L72.4648 145.876L94.9685 132.908V149.553L73.0026 161.773Z",
    fill: "#222222"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_137",
    d: "M39.3041 190.652L37.8701 207.428L51.004 199.862L51.444 186.422L39.3041 190.652Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_138",
    d: "M37.2344 208.437L38.7498 190.604L39.8579 190.702L38.5217 206.419L50.4498 199.537L50.8898 186.406L51.9978 186.439L51.5416 200.188L37.2344 208.437Z",
    fill: "#222222"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_139",
    d: "M68.4231 148.854L59.8193 153.816L47.826 163.042L40.1673 180.5L39.6621 186.423L51.6065 181.672L51.7369 177.555L56.1854 170.494L68.4231 163.693V148.854Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_140",
    d: "M39.027 187.269L39.6463 180.272L47.3702 162.683L59.4612 153.36L68.9613 147.877V164.001L56.5607 170.9L52.275 177.718L52.1284 182.046L39.0107 187.252L39.027 187.269ZM40.7054 180.646L40.2818 185.593L51.0529 181.313L51.1833 177.409L55.7785 170.103L67.8532 163.383V149.829L60.0804 154.32L48.2664 163.432L40.6892 180.679L40.7054 180.646Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_141",
    d: "M68.4238 148.853L72.7421 146.363V161.284L68.4238 163.692V148.853Z",
    fill: "url(#paint14_linear_600_71030)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_142",
    d: "M67.8698 164.636V163.074H68.3913L70.5096 161.886L71.0474 162.846L67.8535 164.619L67.8698 164.636ZM72.0251 162.325L71.4874 161.365L72.188 160.975V159.104H73.2961V161.626L72.0251 162.325ZM68.9779 161.967H67.8698V158.648H68.9779V161.967ZM73.2961 157.981H72.188V154.662H73.2961V157.981ZM68.9779 157.542H67.8698V154.222H68.9779V157.542ZM73.2961 153.555H72.188V150.236H73.2961V153.555ZM68.9779 153.116H67.8698V149.797H68.9779V153.116ZM68.7009 149.341L68.1468 148.381L71.0311 146.722L71.5851 147.682L68.7009 149.341ZM73.2961 149.146H72.188V146.51L71.9925 146.168L73.2961 145.42V149.146Z",
    fill: "#222222"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_143",
    d: "M39.6622 186.423L51.6066 181.672L51.4436 186.423L39.3037 190.653L39.6622 186.423Z",
    fill: "url(#paint15_linear_600_71030)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_144",
    d: "M40.0047 190.994L39.6951 190.132L38.7988 190.051L39.0758 186.748L39.8091 186.813L39.4506 185.918L42.5467 184.681L42.9541 185.706L40.135 186.829H40.1676L39.9069 189.839L42.7586 188.847L43.1171 189.888L39.9721 190.978L40.0047 190.994ZM44.1925 189.53L43.834 188.489L46.979 187.398L47.3375 188.44L44.1925 189.53ZM48.3804 188.066L48.0219 187.024L51.1669 185.934L51.5254 186.975L48.3804 188.066ZM52.0468 185.446L50.9387 185.413L51.0365 182.501L48.1197 183.656L47.7123 182.631L50.8084 181.395L51.0854 182.094L52.1772 182.127L52.0631 185.446H52.0468ZM43.997 185.3L43.5896 184.274L46.6857 183.054L47.0931 184.079L43.997 185.3Z",
    fill: "#222222"
  })))))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_145",
    d: "M23.9538 207.64C23.5301 207.64 23.1227 207.542 22.748 207.331C21.9006 206.843 21.4443 205.883 21.4443 204.613V107.818C21.4443 105.492 23.025 102.758 25.0293 101.603L84.3275 67.4179C85.4193 66.7833 86.4948 66.702 87.3258 67.1901C88.1732 67.6782 88.6294 68.6382 88.6294 69.9073V166.702C88.6294 169.029 87.0488 171.763 85.0282 172.918L25.73 207.103C25.1108 207.461 24.4915 207.64 23.9212 207.64H23.9538ZM86.1526 68.3128C85.843 68.3128 85.4682 68.4267 85.0771 68.6545L25.7789 102.839C24.2145 103.734 22.9109 106.012 22.9109 107.802V204.597C22.9109 205.313 23.1227 205.85 23.4975 206.062C23.8723 206.273 24.4427 206.192 25.0619 205.834L84.3601 171.649C85.9244 170.754 87.2281 168.476 87.2281 166.686V69.891C87.2281 69.1751 87.0162 68.6382 86.6414 68.4267C86.5111 68.3453 86.3481 68.3128 86.1526 68.3128Z",
    fill: "#222222"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "left-location-marker"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_146",
    d: "M67.5602 98.7715C67.5602 98.7715 67.4298 98.7715 67.3646 98.7715C67.332 98.7715 67.2994 98.7715 67.2506 98.7715C65.3766 98.8041 63.2745 99.4549 61.0258 100.854C54.2633 105.052 48.7066 114.766 48.56 122.657C48.4785 126.904 49.8962 129.881 52.2264 131.313L52.3731 131.411L57.1801 134.193C58.5489 135.576 59.5429 137.447 60.0318 139.839L60.2762 141.076C60.2925 141.19 60.3577 141.287 60.4066 141.369C60.4066 141.369 61.7591 144.818 67.218 145.518C67.3972 145.534 67.5765 145.42 67.6091 145.241L73.5894 114.213C74.0457 112.667 74.339 111.137 74.4693 109.624L74.9908 106.923L78.7387 104.531C78.7387 104.531 74.3716 98.7552 67.5765 98.7715H67.5602Z",
    fill: "url(#paint16_linear_600_71030)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_147",
    d: "M67.2507 146.218C67.2507 146.218 67.153 146.218 67.1204 146.218C61.3193 145.485 59.8038 141.792 59.7387 141.646C59.6898 141.532 59.6246 141.385 59.5757 141.206L59.3313 139.97C58.9076 137.838 58.0277 136.097 56.7403 134.763C56.1048 134.389 52.0962 132.062 52.0147 132.029L51.8192 131.899C49.1794 130.288 47.7617 127.002 47.8432 122.641C48.0061 114.441 53.6443 104.613 60.6512 100.253C62.737 98.9509 64.7576 98.235 66.6804 98.1048L67.2507 98.0723H67.5115L67.5441 98.8045V98.0885H67.593C74.6488 98.0885 79.0974 103.881 79.2929 104.125L79.7655 104.743L75.6265 107.379L75.1702 109.771C75.0561 111.203 74.7465 112.797 74.274 114.424L68.3099 145.372C68.2122 145.876 67.7559 146.234 67.2507 146.234V146.218ZM61.1075 141.174C61.3193 141.613 62.6718 144.086 66.9574 144.737L72.8726 114.066C73.3289 112.472 73.6222 110.975 73.7525 109.559L74.3392 106.484L77.6471 104.369C76.3435 102.954 72.6608 99.4878 67.6092 99.4878H67.267C65.4746 99.5041 63.454 100.187 61.4171 101.457C54.8827 105.508 49.4401 115.026 49.2771 122.657C49.1957 126.481 50.3852 129.329 52.6014 130.679L52.7806 130.809L57.5388 133.559L57.6855 133.673C59.2172 135.219 60.2438 137.236 60.7327 139.677L60.9771 140.913L61.0912 141.174H61.1075Z",
    fill: "#222222"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_148",
    d: "M67.0873 122.998L72.204 107.524C72.204 107.524 70.2649 102.106 61.4655 100.561C61.3026 100.658 61.1396 100.723 60.9766 100.821C55.8925 103.977 51.4928 110.258 49.5537 116.539C49.5537 116.539 53.3831 121.55 67.0873 122.998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_149",
    d: "M67.5928 123.779L67.0224 123.714C52.9597 122.234 48.9836 116.962 48.951 116.913L48.7881 116.637L48.8859 116.327C50.9391 109.689 55.5343 103.36 60.6184 100.219C60.7325 100.154 60.8302 100.089 60.9443 100.04L61.3517 99.8125L61.6124 99.8613C70.7214 101.456 72.8235 107.053 72.905 107.281L72.9865 107.509L67.609 123.763L67.5928 123.779ZM50.3687 116.376C51.265 117.271 55.5343 120.948 66.5987 122.217L71.4384 107.557C70.9984 106.581 68.766 102.66 61.5961 101.326C61.5146 101.358 61.4495 101.407 61.368 101.456C56.6587 104.385 52.373 110.21 50.3687 116.392V116.376Z",
    fill: "#222222"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_150",
    d: "M81.1831 111.869C81.1831 103.392 75.0887 100.089 67.6744 104.693C60.9119 108.891 55.3552 118.605 55.2086 126.496C55.1108 131.475 57.0662 134.729 60.1623 135.755C63.4214 136.828 65.833 139.464 66.6804 143.662L66.9248 144.899C67.0552 145.517 67.5766 145.712 68.1959 145.354C68.8151 144.996 69.3365 144.199 69.4669 143.434L69.6461 142.328C70.4935 137.186 72.6444 131.638 75.9524 126.887C79.1299 122.331 81.1831 116.799 81.1831 111.869Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_151",
    d: "M67.6095 146.25C67.4139 146.25 67.2184 146.201 67.0229 146.12C66.5992 145.925 66.3059 145.534 66.2081 145.03L65.9637 143.793C65.2141 140.018 63.112 137.48 59.9345 136.422C56.4147 135.267 54.3778 131.541 54.4919 126.465C54.6548 118.264 60.293 108.437 67.2999 104.076C71.1456 101.684 74.8283 101.229 77.6473 102.791C80.4012 104.32 81.9167 107.542 81.9167 111.87C81.9167 116.784 79.9613 122.397 76.5556 127.295C73.4269 131.769 71.2433 137.155 70.3634 142.443L70.1841 143.549C70.0212 144.542 69.3694 145.518 68.5709 145.973C68.2613 146.152 67.9354 146.25 67.6258 146.25H67.6095ZM73.9809 103.311C72.1884 103.311 70.1678 103.978 68.0495 105.296C61.5151 109.348 56.0725 118.866 55.9095 126.497C55.8118 130.972 57.4413 134.096 60.3744 135.072C64.0408 136.276 66.5177 139.286 67.3651 143.533L67.6095 144.769C67.6095 144.769 67.6747 144.834 67.8213 144.753C68.245 144.509 68.6524 143.891 68.7339 143.338L68.9131 142.231C69.8093 136.732 72.107 131.151 75.3334 126.497C78.5273 121.909 80.4338 116.458 80.4338 111.902C80.4338 108.127 79.1791 105.345 76.914 104.076C76.0341 103.588 75.0401 103.344 73.9646 103.344L73.9809 103.311Z",
    fill: "#222222"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_152",
    d: "M73.3622 122.333C70.5105 127.263 65.8827 129.948 63.0147 128.289C60.1631 126.645 60.1631 121.308 63.0147 116.362C65.8664 111.432 70.4942 108.764 73.3622 110.407C76.2138 112.05 76.2138 117.387 73.3622 122.333Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_153",
    d: "M64.921 129.508C64.1063 129.508 63.3404 129.313 62.656 128.923C59.4132 127.051 59.2992 121.389 62.3953 116.02C63.8455 113.53 65.7684 111.497 67.8216 110.309C70.0051 109.04 72.0909 108.861 73.7041 109.804C75.3174 110.732 76.2136 112.636 76.2136 115.158C76.2136 117.533 75.4151 120.218 73.9812 122.707C72.5309 125.197 70.608 127.23 68.5548 128.418C67.2838 129.15 66.0617 129.508 64.921 129.508ZM71.4554 110.65C70.5754 110.65 69.5977 110.96 68.5548 111.545C66.7135 112.603 64.9699 114.458 63.65 116.736C61.0428 121.243 60.9287 126.254 63.3893 127.67C64.5462 128.337 66.1106 128.158 67.8379 127.165C69.6792 126.108 71.4228 124.253 72.7427 121.975C74.0626 119.697 74.7959 117.273 74.7959 115.141C74.7959 113.156 74.1604 111.708 73.0197 111.041C72.5635 110.781 72.042 110.65 71.4717 110.65H71.4554Z",
    fill: "url(#paint17_linear_600_71030)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_154",
    d: "M65.9307 117.027L68.2772 115.677C69.1897 115.156 69.8578 114.912 70.3141 114.977C70.754 115.042 70.9822 115.4 70.9822 116.051C70.9822 116.49 70.8844 116.913 70.6889 117.336C70.4933 117.759 70.2489 118.101 69.923 118.361V118.41C70.3467 118.296 70.64 118.329 70.8355 118.524C71.0148 118.719 71.1125 119.045 71.1125 119.517C71.1125 120.216 70.8844 120.9 70.4281 121.567C69.9719 122.234 69.3527 122.803 68.5542 123.259L65.947 124.772V117.027H65.9307ZM67.7394 118.947L68.2772 118.638C68.5379 118.492 68.7334 118.313 68.8801 118.101C69.0267 117.89 69.0919 117.678 69.0919 117.434C69.0919 116.995 68.8149 116.946 68.2446 117.271L67.7394 117.564V118.947ZM67.7394 120.477V122.104L68.3749 121.729C68.9453 121.404 69.2223 120.965 69.2223 120.412C69.2223 120.151 69.1408 120.005 68.9942 119.956C68.8475 119.907 68.6194 119.956 68.3424 120.135L67.7394 120.477Z",
    fill: "url(#paint18_linear_600_71030)"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "left-delivery-parcel"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_600_71030",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 304,
    width: 31,
    height: 19
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_155",
    d: "M35.6867 315.123L47.0608 321.713C49.1628 322.933 51.7538 322.917 53.8559 321.696L63.6981 315.286C64.8714 314.586 64.904 312.894 63.7307 312.178L53.3833 305.8C51.3464 304.547 48.7718 304.498 46.686 305.67L35.703 311.983C34.4809 312.666 34.4646 314.423 35.703 315.139L35.6867 315.123Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_600_71030)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_600_71030",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 282,
    width: 80,
    height: 47
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_156",
    d: "M55.4692 328.107L23.6446 309.542C22.4388 308.842 22.4388 307.118 23.6446 306.418L64.0567 283.411C65.4581 282.597 67.1854 282.597 68.5868 283.411L100.411 301.976C101.617 302.676 102.725 305.181 100.444 306.89L63.796 327.749C59.8689 329.783 56.8705 328.904 55.4692 328.091V328.107Z",
    fill: "white"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_600_71030)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_157",
    d: "M77.4091 285.894L27.9023 314.365L28.3171 315.084L77.8239 286.613L77.4091 285.894Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_158",
    d: "M79.6574 287.131L30.1357 315.576L30.5501 316.295L80.0718 287.85L79.6574 287.131Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_159",
    d: "M81.7275 288.388L32.2207 316.859L32.6355 317.578L82.1422 289.107L81.7275 288.388Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_160",
    d: "M84.0046 289.604L34.5078 318.092L34.9228 318.811L84.4196 290.322L84.0046 289.604Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_161",
    d: "M85.9079 290.918L36.4111 319.406L36.8262 320.125L86.323 291.637L85.9079 290.918Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_162",
    d: "M88.2151 292.105L38.6885 320.541L39.1027 321.26L88.6294 292.824L88.2151 292.105Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_163",
    d: "M90.2714 293.375L40.7646 321.846L41.1794 322.565L90.6862 294.094L90.2714 293.375Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_164",
    d: "M92.548 294.592L43.0264 323.037L43.4408 323.756L92.9624 295.311L92.548 294.592Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_165",
    d: "M94.6243 295.855L45.0977 324.291L45.5119 325.01L95.0386 296.574L94.6243 295.855Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_166",
    d: "M96.9121 297.067L47.4004 325.529L47.815 326.248L97.3268 297.786L96.9121 297.067Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_167",
    d: "M98.9784 298.312L49.4717 326.783L49.8864 327.502L99.3932 299.031L98.9784 298.312Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_168",
    d: "M101.263 299.549L51.7412 327.994L52.1556 328.713L101.677 300.268L101.263 299.549Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_169",
    d: "M103.144 300.859L53.6475 329.348L54.0625 330.067L103.559 301.578L103.144 300.859Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_170",
    d: "M105.416 302.074L55.9189 330.562L56.334 331.281L105.831 302.793L105.416 302.074Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_171",
    d: "M107.463 303.354L57.9658 331.842L58.3808 332.561L107.878 304.072L107.463 303.354Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_172",
    d: "M109.785 304.529L60.2881 333.018L60.7031 333.737L110.2 305.248L109.785 304.529Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_173",
    d: "M111.832 305.824L62.335 334.312L62.75 335.031L112.247 306.543L111.832 305.824Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_174",
    d: "M68.571 281.033L19.0742 309.521L19.4893 310.24L68.9861 281.752L68.571 281.033Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_175",
    d: "M70.8516 282.249L21.3398 310.711L21.7545 311.43L71.2662 282.968L70.8516 282.249Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_176",
    d: "M72.927 283.518L23.4053 311.963L23.8197 312.682L73.3413 284.237L72.927 283.518Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_177",
    d: "M75.2129 284.692L25.7012 313.154L26.1158 313.873L75.6276 285.411L75.2129 284.692Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_178",
    d: "M77.3011 285.974L27.7744 314.41L28.1887 315.13L77.7153 286.693L77.3011 285.974Z",
    fill: "#222222"
  }))))))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_179",
    d: "M59.7064 294.168L36.3554 294.201C36.0947 294.201 35.8828 294.412 35.8828 294.689V306.111V307.412C35.9317 308.128 36.4694 308.861 37.4797 309.446L44.503 313.498C46.4421 314.62 49.3915 314.734 51.0699 313.774L59.0383 309.186C59.8531 308.714 60.2115 308.08 60.1627 307.429V294.656C60.1627 294.396 59.9508 294.168 59.6738 294.184L59.7064 294.168Z",
    fill: "url(#paint19_linear_600_71030)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_180",
    d: "M48.2182 315.141C46.8005 315.141 45.3176 314.799 44.1444 314.116L37.1211 310.064C35.9316 309.381 35.2472 308.454 35.1657 307.461V306.111L35.1494 294.672C35.1494 294.005 35.6872 293.468 36.3553 293.468L59.7063 293.436C60.3744 293.436 60.9121 293.972 60.9121 294.64V308.128H60.8307C60.6514 308.779 60.1625 309.365 59.4293 309.788L51.4609 314.376C50.581 314.881 49.4403 315.125 48.2345 315.125L48.2182 315.141ZM36.5834 294.916V307.396C36.6323 307.851 37.0885 308.388 37.8381 308.811L44.8614 312.863C46.5723 313.855 49.2611 313.969 50.7113 313.14L58.6797 308.551C59.0545 308.34 59.4781 307.982 59.4456 307.461L59.3804 306.696H59.4456V294.884L36.5671 294.916H36.5834Z",
    fill: "#222222"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_181",
    d: "M59.706 294.182H48.9512V314.391C49.7496 314.309 50.4992 314.114 51.0858 313.772L59.0542 309.184C59.869 308.712 60.2274 308.078 60.1786 307.427V294.654C60.1786 294.394 59.9667 294.166 59.6897 294.166L59.706 294.182Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_182",
    d: "M59.0542 295.957L51.0858 300.545C49.4074 301.522 46.458 301.391 44.5188 300.269L37.4956 296.217C35.5565 295.095 35.3446 293.402 37.023 292.426L44.9914 287.838C46.6698 286.862 49.6192 286.992 51.5584 288.114L58.5816 292.166C60.5207 293.289 60.7326 294.981 59.0542 295.957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_183",
    d: "M48.2182 301.928C46.8005 301.928 45.3176 301.586 44.1444 300.903L37.1211 296.851C35.8664 296.136 35.1494 295.127 35.1494 294.085C35.1494 293.174 35.6872 292.377 36.6486 291.824L44.6169 287.235C46.5235 286.129 49.7336 286.259 51.9172 287.512L58.9404 291.563C60.1951 292.279 60.9121 293.288 60.9121 294.329C60.9121 295.241 60.3744 296.038 59.413 296.591L51.4446 301.18C50.5647 301.684 49.424 301.928 48.2182 301.928ZM47.8271 287.903C46.882 287.903 45.9857 288.081 45.3339 288.456L37.3656 293.044C37.0071 293.256 36.5834 293.597 36.5834 294.069C36.5834 294.574 37.056 295.143 37.8381 295.599L44.8614 299.65C46.5723 300.643 49.2611 300.756 50.7113 299.927L58.6797 295.338C59.0382 295.127 59.4619 294.785 59.4619 294.313C59.4619 293.809 58.9893 293.239 58.2071 292.8L51.1839 288.749C50.2388 288.195 48.984 287.919 47.8108 287.919L47.8271 287.903Z",
    fill: "#222222"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_184",
    d: "M58.1586 298.707H56.7246V307.998H58.1586V298.707Z",
    fill: "url(#paint20_linear_600_71030)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_185",
    d: "M49.3425 293.224L46.2301 291.418L44.8613 292.199L43.5088 292.98L46.6212 294.786L45.0731 295.681L51.7053 296.136L50.9068 292.313L49.3425 293.224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_186",
    d: "M52.3893 296.738L43.2152 296.104L45.5128 294.786L42.4004 292.996L46.2298 290.783L49.3421 292.573L51.2813 291.45L52.3893 296.738ZM46.9142 295.241L51.0043 295.518L50.5154 293.159L49.3421 293.842L46.2298 292.036L44.6165 292.963L47.7289 294.753L46.9142 295.225V295.241Z",
    fill: "#222222"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_187",
    d: "M46.3441 304.287H44.9102V313.985H46.3441V304.287Z",
    fill: "#222222"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group 481820"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_188",
    d: "M272.952 328.723L194.765 373.872L134.386 338.995L212.573 293.846L272.952 328.723Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_189",
    d: "M195.428 322.095V356.309L228.199 337.255V303.041L215.803 310.248V317.152C215.803 317.373 215.693 317.594 215.472 317.704L209.26 321.294C209.26 321.294 209.039 321.377 208.928 321.377C208.818 321.377 208.708 321.349 208.597 321.294C208.404 321.184 208.266 320.963 208.266 320.742V314.611L195.4 322.095H195.428ZM210.585 330.269C210.778 330.158 211.027 330.158 211.22 330.269C211.413 330.379 211.551 330.6 211.551 330.821V341.232C211.551 341.453 211.441 341.674 211.22 341.784L198.989 348.853C198.989 348.853 198.769 348.936 198.658 348.936C198.548 348.936 198.437 348.909 198.327 348.853C198.134 348.743 197.996 348.522 197.996 348.301V337.89C197.996 337.67 198.106 337.449 198.327 337.338L210.557 330.269H210.585Z",
    fill: "#D0E1EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_190",
    d: "M229.221 301.385C229.221 301.385 229.332 301.468 229.387 301.551C229.387 301.551 229.415 301.606 229.442 301.606C229.497 301.689 229.525 301.799 229.525 301.882V333.694L232.01 335.13V300.916L179.333 270.484V272.5L229.221 301.302C229.221 301.302 229.221 301.33 229.249 301.33L229.221 301.385Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_191",
    d: "M145.431 324.388L151.035 327.619V315.137L145.431 311.906V324.388Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_192",
    d: "M207.741 313.451L155.065 283.02L142.116 290.558L194.793 320.962L207.741 313.451Z",
    fill: "url(#paint21_linear_600_71030)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_193",
    d: "M227.592 301.91L178.532 273.577C178.532 273.577 178.283 273.494 178.201 273.384L174.915 271.479L162.768 278.548L215.444 308.979L227.592 301.91Z",
    fill: "url(#paint22_linear_600_71030)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_194",
    d: "M214.147 309.724L161.47 279.293L156.362 282.275L209.039 312.706L214.147 309.724Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_195",
    d: "M209.592 313.866V319.61L214.534 316.766V310.994L209.592 313.866Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_196",
    d: "M233.252 300.943V335.157L266.023 316.103V281.889L253.627 289.096V296C253.627 296.221 253.517 296.442 253.296 296.552L247.084 300.142C247.084 300.142 246.863 300.225 246.753 300.225C246.642 300.225 246.532 300.197 246.421 300.142C246.228 300.031 246.09 299.81 246.09 299.59V293.459L233.225 300.943H233.252ZM248.409 309.117C248.602 309.006 248.851 309.006 249.044 309.117C249.237 309.227 249.375 309.448 249.375 309.669V320.079C249.375 320.3 249.265 320.521 249.044 320.632L236.814 327.701C236.814 327.701 236.593 327.784 236.482 327.784C236.372 327.784 236.262 327.756 236.151 327.701C235.958 327.591 235.82 327.37 235.82 327.149V316.738C235.82 316.517 235.93 316.296 236.151 316.186L248.382 309.117H248.409Z",
    fill: "#D0E1EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_197",
    d: "M247.415 292.713V298.485L252.357 295.641V289.869L247.415 292.713Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_198",
    d: "M245.564 292.3L192.888 261.896L179.939 269.408L232.616 299.839L245.564 292.3Z",
    fill: "url(#paint23_linear_600_71030)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_199",
    d: "M251.97 288.599L199.293 258.168L194.186 261.15L246.862 291.554L251.97 288.599Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_200",
    d: "M265.416 280.785L212.712 250.354L200.564 257.423L253.241 287.854L265.416 280.785Z",
    fill: "url(#paint24_linear_600_71030)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_201",
    d: "M135.325 338.223L194.103 372.161V361.999L135.325 328.061V338.223ZM165.722 347.998C165.722 347.777 165.832 347.556 166.053 347.446C166.247 347.335 166.495 347.335 166.688 347.446L188.057 359.79C188.25 359.9 188.388 360.121 188.388 360.342V366.362C188.388 366.583 188.278 366.804 188.057 366.914C187.947 366.969 187.836 366.997 187.726 366.997C187.615 366.997 187.505 366.969 187.395 366.914L166.026 354.57C165.832 354.46 165.694 354.239 165.694 354.018V347.998H165.722ZM141.04 333.749C141.04 333.528 141.151 333.307 141.371 333.197C141.565 333.086 141.813 333.086 142.006 333.197L163.375 345.541C163.569 345.651 163.707 345.872 163.707 346.093V352.113C163.707 352.334 163.596 352.555 163.375 352.665C163.265 352.72 163.154 352.748 163.044 352.748C162.934 352.748 162.823 352.72 162.713 352.665L141.344 340.321C141.151 340.211 141.013 339.99 141.013 339.769V333.749H141.04Z",
    fill: "#DFD9E4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_202",
    d: "M267.32 314.943V316.462C267.32 316.462 267.32 316.517 267.32 316.545C267.32 316.6 267.32 316.628 267.32 316.683C267.32 316.711 267.292 316.766 267.265 316.794C267.265 316.821 267.237 316.876 267.209 316.904C267.182 316.932 267.154 316.959 267.099 316.987C267.099 316.987 267.071 317.014 267.044 317.042L232.975 336.842C232.975 336.842 232.975 336.842 232.948 336.842C232.865 336.897 232.754 336.924 232.644 336.924C232.533 336.924 232.451 336.897 232.34 336.842C232.34 336.842 232.34 336.842 232.313 336.842L229.524 335.24V337.642C229.524 337.642 229.524 337.698 229.524 337.725C229.524 337.781 229.524 337.808 229.524 337.863C229.524 337.891 229.496 337.946 229.469 337.974C229.469 338.001 229.441 338.057 229.414 338.084C229.386 338.112 229.358 338.14 229.303 338.167C229.303 338.167 229.276 338.195 229.248 338.222L195.179 358.022C195.179 358.022 195.179 358.022 195.152 358.022C195.069 358.077 194.958 358.105 194.848 358.105C194.738 358.105 194.655 358.077 194.544 358.022C194.544 358.022 194.544 358.022 194.517 358.022L140.515 326.79C140.515 326.79 140.487 326.762 140.46 326.735C140.432 326.735 140.377 326.68 140.349 326.652C140.349 326.624 140.294 326.597 140.294 326.541C140.294 326.514 140.266 326.459 140.239 326.431C140.239 326.376 140.239 326.348 140.239 326.293C140.239 326.293 140.239 326.238 140.239 326.21V324.47L136.015 326.928L195.014 361.004L271.075 317.07L267.375 314.943H267.32Z",
    fill: "url(#paint25_radial_600_71030)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_203",
    d: "M195.373 372.409L199.708 369.896V363.047C199.708 362.826 199.818 362.606 200.039 362.495L261.081 327.121C261.081 327.121 261.136 327.093 261.164 327.066L267.182 323.586C267.376 323.476 267.624 323.476 267.817 323.586C268.011 323.697 268.149 323.918 268.149 324.139V330.241L271.683 328.308V318.174L195.401 362.219V372.381L195.373 372.409Z",
    fill: "#C2BACC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_204",
    d: "M162.409 346.451L142.311 334.881V339.41L162.409 351.008V346.451Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_205",
    d: "M266.851 330.214V325.271L262.737 327.674L266.851 330.214Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_206",
    d: "M194.159 322.095L141.482 291.664V325.878L194.159 356.31V322.095ZM152.305 328.75C152.305 328.971 152.194 329.192 151.974 329.303C151.863 329.358 151.753 329.385 151.642 329.385C151.532 329.385 151.421 329.358 151.311 329.303L144.437 325.326C144.243 325.216 144.105 324.995 144.105 324.774V310.801C144.105 310.58 144.216 310.359 144.437 310.249C144.63 310.138 144.878 310.138 145.072 310.249L151.946 314.225C152.139 314.336 152.277 314.556 152.277 314.777V328.75H152.305ZM163.459 335.102C163.459 335.323 163.348 335.543 163.127 335.654C163.017 335.709 162.906 335.737 162.796 335.737C162.686 335.737 162.575 335.709 162.465 335.654L155.59 331.677C155.397 331.567 155.259 331.346 155.259 331.125V317.152C155.259 316.931 155.369 316.71 155.59 316.6C155.784 316.489 156.032 316.489 156.225 316.6L163.1 320.576C163.293 320.687 163.431 320.908 163.431 321.129V335.102H163.459Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_207",
    d: "M187.092 360.7L166.993 349.102V353.63L187.092 365.228V360.7Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_208",
    d: "M156.584 330.74L162.161 333.97V321.489L156.584 318.258V330.74Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_209",
    d: "M272.842 316.738C272.842 316.738 272.76 316.628 272.677 316.573C272.677 316.573 272.677 316.545 272.649 316.545L267.348 313.48V280.784C267.348 280.674 267.321 280.591 267.265 280.508C267.265 280.508 267.238 280.453 267.21 280.425C267.155 280.37 267.127 280.315 267.045 280.26C267.045 280.26 267.045 280.232 267.017 280.232L213.043 249.083C212.849 248.972 212.601 248.972 212.408 249.083L178.339 268.882C178.339 268.882 178.339 268.91 178.311 268.91C178.256 268.965 178.201 268.993 178.146 269.076C178.146 269.076 178.118 269.131 178.091 269.131C178.035 269.214 178.008 269.324 178.008 269.435V271.837L175.219 270.236C175.026 270.125 174.778 270.125 174.584 270.236L140.516 290.035C140.516 290.035 140.516 290.063 140.488 290.063C140.433 290.118 140.378 290.146 140.322 290.228C140.322 290.228 140.295 290.284 140.267 290.284C140.212 290.366 140.184 290.477 140.184 290.587V323.062L134.331 326.431C134.331 326.431 134.331 326.459 134.304 326.459C134.248 326.514 134.193 326.541 134.138 326.624C134.138 326.624 134.11 326.68 134.083 326.707C134.028 326.79 134 326.9 134 327.011V338.664C134 338.664 134 338.719 134 338.747C134 338.802 134 338.83 134 338.885C134 338.913 134.028 338.968 134.055 338.996C134.055 339.023 134.083 339.051 134.11 339.106C134.138 339.134 134.166 339.161 134.221 339.189C134.221 339.189 134.248 339.216 134.276 339.244L194.103 373.79C194.214 374.011 194.435 374.149 194.683 374.149C194.738 374.149 194.766 374.149 194.821 374.149C194.849 374.149 194.876 374.149 194.904 374.149C195.014 374.149 195.125 374.121 195.235 374.066L200.647 370.946C200.647 370.946 200.674 370.918 200.702 370.89C200.729 370.89 200.785 370.835 200.812 370.807C200.812 370.78 200.867 370.752 200.867 370.697C200.867 370.669 200.895 370.614 200.923 370.587C200.923 370.531 200.923 370.504 200.923 370.448C200.923 370.448 200.923 370.393 200.923 370.366V363.517L261.385 328.474L267.072 331.981C267.072 331.981 267.072 331.981 267.1 331.981C267.183 332.037 267.293 332.064 267.404 332.064C267.514 332.064 267.597 332.037 267.68 331.981C267.68 331.981 267.68 331.981 267.707 331.981L272.539 329.358C272.732 329.248 272.87 329.027 272.87 328.806V317.153C272.87 317.153 272.842 316.959 272.787 316.849C272.787 316.849 272.76 316.794 272.732 316.794L272.842 316.738ZM246.449 300.17C246.449 300.17 246.67 300.252 246.78 300.252C246.891 300.252 247.001 300.225 247.111 300.17L253.323 296.58C253.517 296.469 253.655 296.248 253.655 296.027V289.124L266.051 281.916V316.131L233.28 335.185V300.97L246.145 293.487V299.617C246.145 299.838 246.256 300.059 246.476 300.17H246.449ZM247.415 298.513V292.741L252.357 289.869V295.641L247.415 298.485V298.513ZM212.739 250.381L265.416 280.812L253.268 287.881L200.591 257.45L212.739 250.381ZM199.321 258.196L251.998 288.627L246.891 291.609L194.214 261.178L199.321 258.196ZM192.916 261.924L245.593 292.355L232.645 299.893L179.968 269.462L192.916 261.924ZM179.333 270.567L232.01 300.998V335.212L229.525 333.776V301.965C229.525 301.854 229.497 301.771 229.442 301.688C229.442 301.688 229.414 301.633 229.387 301.633C229.332 301.578 229.304 301.523 229.221 301.468C229.221 301.468 229.221 301.44 229.194 301.44L179.305 272.638V270.622L179.333 270.567ZM208.653 321.322C208.653 321.322 208.874 321.405 208.984 321.405C209.095 321.405 209.205 321.378 209.316 321.322L215.527 317.732C215.721 317.622 215.859 317.401 215.859 317.18V310.277L228.255 303.069V337.283L195.484 356.337V322.123L208.349 314.64V320.77C208.349 320.991 208.46 321.212 208.681 321.322H208.653ZM209.619 319.665V313.894L214.561 311.022V316.794L209.619 319.638V319.665ZM174.943 271.533L178.229 273.439C178.229 273.439 178.422 273.604 178.56 273.632L227.62 301.965L215.472 309.034L162.796 278.603L174.943 271.533ZM161.526 279.348L214.202 309.779L209.095 312.762L156.418 282.331L161.526 279.348ZM155.12 283.076L207.797 313.507L194.849 321.046L142.117 290.56L155.065 283.021L155.12 283.076ZM141.537 291.72L194.214 322.151V356.365L141.482 325.879V291.664L141.537 291.72ZM194.159 372.216L135.325 338.222V328.06L194.103 361.998V372.161L194.159 372.216ZM195.014 361.087L135.96 326.956L140.184 324.498V326.238C140.184 326.238 140.184 326.293 140.184 326.321C140.184 326.376 140.184 326.403 140.184 326.459C140.184 326.486 140.212 326.541 140.239 326.569C140.239 326.597 140.267 326.624 140.295 326.68C140.322 326.707 140.35 326.735 140.405 326.762C140.405 326.762 140.433 326.79 140.46 326.818L194.435 357.967C194.435 357.967 194.435 357.967 194.462 357.967C194.545 358.022 194.656 358.05 194.766 358.05C194.876 358.05 194.959 358.022 195.07 357.967C195.07 357.967 195.07 357.967 195.097 357.967L229.166 338.167C229.166 338.167 229.194 338.14 229.221 338.112C229.249 338.112 229.276 338.057 229.332 338.029C229.359 338.001 229.387 337.974 229.387 337.919C229.387 337.891 229.414 337.863 229.442 337.808C229.442 337.753 229.442 337.725 229.442 337.67C229.442 337.67 229.442 337.615 229.442 337.587V335.185L232.23 336.786C232.23 336.786 232.23 336.786 232.258 336.786C232.341 336.842 232.451 336.869 232.562 336.869C232.672 336.869 232.755 336.842 232.865 336.786C232.865 336.786 232.865 336.786 232.893 336.786L266.962 316.987C266.962 316.987 266.989 316.959 267.017 316.932C267.045 316.932 267.072 316.876 267.127 316.849C267.127 316.821 267.183 316.794 267.183 316.738C267.183 316.711 267.21 316.655 267.238 316.628C267.238 316.573 267.238 316.545 267.238 316.49C267.238 316.49 267.238 316.435 267.238 316.407V314.888L270.937 317.014L194.876 360.949L195.014 361.087ZM266.907 330.269L262.793 327.729L266.907 325.354V330.297V330.269ZM271.738 328.419L268.204 330.352V324.249C268.204 324.029 268.094 323.808 267.873 323.697C267.68 323.587 267.431 323.587 267.238 323.697L261.219 327.177C261.219 327.177 261.164 327.177 261.136 327.232L200.094 362.606C199.901 362.716 199.763 362.937 199.763 363.158V370.007L195.429 372.52V362.357L271.71 318.312V328.447L271.738 328.419Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_210",
    d: "M152 314.198L145.125 310.222C144.932 310.111 144.684 310.111 144.49 310.222C144.297 310.332 144.159 310.553 144.159 310.774V324.747C144.159 324.968 144.27 325.189 144.49 325.299L151.365 329.275C151.365 329.275 151.586 329.358 151.696 329.358C151.807 329.358 151.917 329.331 152.028 329.275C152.221 329.165 152.359 328.944 152.359 328.723V314.75C152.359 314.529 152.248 314.308 152.028 314.198H152ZM151.034 327.619L145.429 324.388V311.906L151.034 315.137V327.619Z",
    fill: "url(#paint26_linear_600_71030)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_211",
    d: "M163.126 320.55L156.251 316.573C156.058 316.463 155.81 316.463 155.616 316.573C155.423 316.684 155.285 316.904 155.285 317.125V331.098C155.285 331.319 155.396 331.54 155.616 331.651L162.491 335.627C162.491 335.627 162.712 335.71 162.822 335.71C162.933 335.71 163.043 335.682 163.154 335.627C163.347 335.517 163.485 335.296 163.485 335.075V321.102C163.485 320.881 163.374 320.66 163.154 320.55H163.126ZM162.16 333.97L156.555 330.739V318.258L162.16 321.488V333.97Z",
    fill: "url(#paint27_linear_600_71030)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_212",
    d: "M141.371 340.321L162.74 352.664C162.74 352.664 162.961 352.747 163.071 352.747C163.182 352.747 163.292 352.72 163.403 352.664C163.596 352.554 163.734 352.333 163.734 352.112V346.092C163.734 345.871 163.623 345.65 163.403 345.54L142.034 333.196C141.84 333.086 141.592 333.086 141.399 333.196C141.205 333.307 141.067 333.527 141.067 333.748V339.768C141.067 339.989 141.178 340.21 141.399 340.321H141.371ZM142.337 334.853L162.409 346.451V350.98L142.337 339.382V334.853Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_213",
    d: "M166.025 354.571L187.394 366.914C187.394 366.914 187.615 366.997 187.726 366.997C187.836 366.997 187.946 366.97 188.057 366.914C188.25 366.804 188.388 366.583 188.388 366.362V360.342C188.388 360.121 188.278 359.9 188.057 359.79L166.688 347.446C166.495 347.336 166.246 347.336 166.053 347.446C165.86 347.557 165.722 347.778 165.722 347.998V354.018C165.722 354.239 165.832 354.46 166.053 354.571H166.025ZM166.992 349.103L187.063 360.701V365.23L166.992 353.632V349.103Z",
    fill: "#222222"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "left-square-wrap"
  }, /*#__PURE__*/React.createElement("g", {
    className: "left-dots-square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_214",
    d: "M292.265 202.768C293.086 203.243 293.086 204.02 292.265 204.539C291.445 205.013 290.063 205.013 289.2 204.539C288.336 204.064 288.38 203.286 289.2 202.768C290.02 202.293 291.402 202.293 292.265 202.768Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_215",
    d: "M300.21 198.194C301.03 198.669 301.03 199.446 300.21 199.964C299.39 200.439 298.008 200.439 297.145 199.964C296.324 199.489 296.324 198.712 297.145 198.194C297.965 197.719 299.347 197.719 300.21 198.194Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_216",
    d: "M308.198 193.571C309.019 194.046 309.019 194.823 308.198 195.341C307.378 195.816 305.996 195.816 305.133 195.341C304.312 194.866 304.312 194.089 305.133 193.571C305.953 193.096 307.335 193.096 308.198 193.571Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_217",
    d: "M316.143 188.997C316.963 189.472 316.963 190.249 316.143 190.767C315.322 191.242 313.941 191.242 313.077 190.767C312.257 190.292 312.257 189.515 313.077 188.997C313.898 188.522 315.279 188.522 316.143 188.997Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_218",
    d: "M324.087 184.376C324.907 184.851 324.907 185.628 324.087 186.146C323.267 186.621 321.885 186.621 321.022 186.146C320.201 185.671 320.201 184.894 321.022 184.376C321.842 183.901 323.223 183.901 324.087 184.376Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_219",
    d: "M284.278 198.194C285.099 198.669 285.099 199.446 284.278 199.964C283.458 200.439 282.076 200.439 281.213 199.964C280.393 199.489 280.393 198.712 281.213 198.194C282.033 197.719 283.415 197.719 284.278 198.194Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_220",
    d: "M292.267 193.571C293.087 194.046 293.087 194.823 292.267 195.341C291.446 195.816 290.065 195.816 289.201 195.341C288.381 194.866 288.381 194.089 289.201 193.571C290.022 193.096 291.403 193.096 292.267 193.571Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_221",
    d: "M300.212 188.997C301.032 189.472 301.032 190.249 300.212 190.767C299.391 191.242 298.01 191.242 297.146 190.767C296.283 190.292 296.326 189.515 297.146 188.997C297.967 188.522 299.348 188.522 300.212 188.997Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_222",
    d: "M308.198 184.376C309.019 184.851 309.019 185.628 308.198 186.146C307.378 186.621 305.996 186.621 305.133 186.146C304.312 185.671 304.312 184.894 305.133 184.376C305.953 183.901 307.335 183.901 308.198 184.376Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_223",
    d: "M316.143 179.8C316.963 180.274 316.963 181.052 316.143 181.57C315.322 182.045 313.941 182.045 313.077 181.57C312.257 181.095 312.257 180.318 313.077 179.8C313.898 179.325 315.279 179.325 316.143 179.8Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_224",
    d: "M284.279 188.997C285.099 189.472 285.099 190.249 284.279 190.767C283.459 191.285 282.077 191.242 281.214 190.767C280.35 190.292 280.393 189.515 281.214 188.997C282.034 188.522 283.416 188.522 284.279 188.997Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_225",
    d: "M292.267 184.376C293.087 184.851 293.087 185.628 292.267 186.146C291.446 186.621 290.065 186.621 289.201 186.146C288.381 185.671 288.381 184.894 289.201 184.376C290.022 183.901 291.403 183.901 292.267 184.376Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_226",
    d: "M300.21 179.8C301.03 180.274 301.03 181.052 300.21 181.57C299.39 182.045 298.008 182.045 297.145 181.57C296.324 181.095 296.324 180.318 297.145 179.8C297.965 179.325 299.347 179.325 300.21 179.8Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_227",
    d: "M308.198 175.182C309.019 175.657 309.019 176.434 308.198 176.953C307.378 177.428 305.996 177.428 305.133 176.953C304.312 176.478 304.312 175.7 305.133 175.182C305.953 174.707 307.335 174.707 308.198 175.182Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_228",
    d: "M284.278 179.8C285.099 180.274 285.099 181.052 284.278 181.57C283.458 182.045 282.076 182.045 281.213 181.57C280.393 181.095 280.393 180.318 281.213 179.8C282.033 179.325 283.415 179.325 284.278 179.8Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_229",
    d: "M292.265 175.182C293.086 175.657 293.086 176.434 292.265 176.953C291.445 177.428 290.063 177.428 289.2 176.953C288.336 176.478 288.38 175.7 289.2 175.182C290.02 174.707 291.402 174.707 292.265 175.182Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_230",
    d: "M300.212 170.604C301.032 171.079 301.032 171.856 300.212 172.374C299.391 172.893 298.01 172.849 297.146 172.374C296.283 171.9 296.326 171.122 297.146 170.604C297.967 170.129 299.348 170.129 300.212 170.604Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_231",
    d: "M284.279 170.604C285.1 171.079 285.1 171.856 284.279 172.374C283.459 172.849 282.077 172.849 281.214 172.374C280.394 171.9 280.394 171.122 281.214 170.604C282.034 170.129 283.416 170.129 284.279 170.604Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_232",
    d: "M316.444 215.85C317.264 216.325 317.264 217.102 316.444 217.621C315.624 218.095 314.242 218.095 313.379 217.621C312.515 217.146 312.558 216.368 313.379 215.85C314.199 215.375 315.581 215.375 316.444 215.85Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_233",
    d: "M324.433 211.231C325.253 211.706 325.253 212.483 324.433 213.001C323.612 213.52 322.231 213.476 321.367 213.001C320.547 212.526 320.547 211.749 321.367 211.231C322.188 210.756 323.569 210.756 324.433 211.231Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_234",
    d: "M332.376 206.656C333.196 207.131 333.196 207.908 332.376 208.426C331.556 208.901 330.174 208.901 329.311 208.426C328.49 207.951 328.49 207.174 329.311 206.656C330.131 206.138 331.513 206.181 332.376 206.656Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_235",
    d: "M340.364 202.036C341.185 202.511 341.185 203.288 340.364 203.806C339.544 204.281 338.162 204.281 337.299 203.806C336.479 203.331 336.479 202.554 337.299 202.036C338.119 201.561 339.501 201.561 340.364 202.036Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_236",
    d: "M348.31 197.458C349.13 197.933 349.13 198.71 348.31 199.228C347.489 199.703 346.108 199.703 345.244 199.228C344.424 198.753 344.424 197.976 345.244 197.458C346.065 196.983 347.446 196.983 348.31 197.458Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_237",
    d: "M308.5 211.231C309.32 211.706 309.32 212.483 308.5 213.001C307.68 213.476 306.298 213.476 305.435 213.001C304.614 212.526 304.614 211.749 305.435 211.231C306.255 210.756 307.637 210.756 308.5 211.231Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_238",
    d: "M316.444 206.656C317.265 207.131 317.265 207.908 316.444 208.426C315.624 208.901 314.242 208.901 313.379 208.426C312.559 207.951 312.559 207.174 313.379 206.656C314.199 206.138 315.581 206.181 316.444 206.656Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_239",
    d: "M324.433 202.036C325.253 202.511 325.253 203.288 324.433 203.806C323.612 204.281 322.231 204.281 321.367 203.806C320.547 203.331 320.547 202.554 321.367 202.036C322.188 201.561 323.569 201.561 324.433 202.036Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_240",
    d: "M332.377 197.458C333.197 197.933 333.197 198.71 332.377 199.228C331.556 199.746 330.175 199.703 329.311 199.228C328.448 198.753 328.491 197.976 329.311 197.458C330.132 196.983 331.513 196.983 332.377 197.458Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_241",
    d: "M340.364 192.841C341.185 193.316 341.185 194.093 340.364 194.611C339.544 195.086 338.162 195.086 337.299 194.611C336.479 194.136 336.479 193.359 337.299 192.841C338.119 192.366 339.501 192.366 340.364 192.841Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_242",
    d: "M300.513 206.655C301.333 207.13 301.333 207.907 300.513 208.425C299.692 208.9 298.311 208.9 297.447 208.425C296.627 207.95 296.627 207.173 297.447 206.655C298.268 206.18 299.649 206.18 300.513 206.655Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_243",
    d: "M308.5 202.036C309.32 202.511 309.32 203.288 308.5 203.806C307.68 204.281 306.298 204.281 305.435 203.806C304.614 203.331 304.614 202.554 305.435 202.036C306.255 201.561 307.637 201.561 308.5 202.036Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_244",
    d: "M316.444 197.458C317.264 197.933 317.264 198.71 316.444 199.228C315.624 199.746 314.242 199.703 313.379 199.228C312.515 198.753 312.558 197.976 313.379 197.458C314.199 196.983 315.581 196.983 316.444 197.458Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_245",
    d: "M324.433 192.841C325.253 193.316 325.253 194.093 324.433 194.611C323.612 195.086 322.231 195.086 321.367 194.611C320.547 194.136 320.547 193.359 321.367 192.841C322.188 192.366 323.569 192.366 324.433 192.841Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_246",
    d: "M332.376 188.26C333.196 188.735 333.196 189.513 332.376 190.031C331.556 190.506 330.174 190.506 329.311 190.031C328.49 189.556 328.49 188.779 329.311 188.26C330.131 187.786 331.513 187.786 332.376 188.26Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_247",
    d: "M332.075 179.844C332.896 180.319 332.896 181.097 332.075 181.615C331.255 182.09 329.873 182.09 329.01 181.615C328.189 181.14 328.189 180.363 329.01 179.844C329.83 179.37 331.212 179.37 332.075 179.844Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_248",
    d: "M340.061 175.266C340.881 175.741 340.881 176.518 340.061 177.037C339.24 177.511 337.859 177.511 336.995 177.037C336.175 176.562 336.175 175.784 336.995 175.266C337.815 174.791 339.197 174.791 340.061 175.266Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_249",
    d: "M348.007 170.645C348.827 171.12 348.827 171.897 348.007 172.415C347.187 172.934 345.805 172.89 344.941 172.415C344.121 171.941 344.121 171.163 344.941 170.645C345.762 170.17 347.143 170.17 348.007 170.645Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_250",
    d: "M321.065 175.266C321.885 174.791 323.267 174.791 324.13 175.266C324.994 175.741 324.994 176.518 324.13 177.037C323.31 177.511 321.928 177.511 321.065 177.037C320.201 176.562 320.201 175.784 321.065 175.266Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_251",
    d: "M332.074 170.646C332.894 171.121 332.894 171.898 332.074 172.416C331.254 172.891 329.872 172.891 329.009 172.416C328.145 171.941 328.188 171.164 329.009 170.646C329.829 170.128 331.21 170.171 332.074 170.646Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_252",
    d: "M313.121 170.645C313.942 170.17 315.323 170.17 316.187 170.645C317.05 171.12 317.05 171.897 316.187 172.415C315.366 172.89 313.985 172.89 313.121 172.415C312.258 171.941 312.258 171.163 313.121 170.645Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_253",
    d: "M345.286 188.305C346.107 187.83 347.488 187.83 348.352 188.305C349.215 188.78 349.215 189.558 348.352 190.076C347.531 190.551 346.15 190.551 345.286 190.076C344.423 189.601 344.423 188.824 345.286 188.305Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_254",
    d: "M337.299 183.729C338.119 183.254 339.501 183.254 340.364 183.729C341.228 184.204 341.228 184.981 340.364 185.499C339.544 185.974 338.163 185.974 337.299 185.499C336.435 185.025 336.435 184.247 337.299 183.729Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_255",
    d: "M348.354 179.108C349.174 179.583 349.174 180.36 348.354 180.878C347.533 181.353 346.152 181.353 345.288 180.878C344.468 180.403 344.468 179.626 345.288 179.108C346.108 178.633 347.49 178.633 348.354 179.108Z",
    fill: "#A5A5A5"
  })), /*#__PURE__*/React.createElement("g", {
    className: "left-stacks-vertical",
    clipPath: "url(#clip0_600_71030)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_256",
    d: "M347.629 177.717L347.612 183.264L316.029 201.385L316.047 195.838L347.629 177.717Z",
    fill: "url(#paint28_linear_600_71030)",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_257",
    d: "M316.047 195.836L316.029 201.384L279.352 180.477L279.369 174.93L316.047 195.836Z",
    fill: "url(#paint29_linear_600_71030)",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_258",
    d: "M331.703 163.082L331.735 168.657L347.629 177.716L316.047 195.837L279.369 174.93L315.812 154.023L331.703 163.082Z",
    fill: "#222222",
    stroke: "url(#paint30_linear_600_71030)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_259",
    d: "M313.499 180.765C319.155 180.765 323.74 178.152 323.74 174.929C323.74 171.707 319.155 169.094 313.499 169.094C307.844 169.094 303.259 171.707 303.259 174.929C303.259 178.152 307.844 180.765 313.499 180.765Z",
    fill: "url(#paint31_linear_600_71030)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_260",
    d: "M310.034 175.844C309.852 175.74 309.739 175.597 309.736 175.441L309.676 173.349C309.665 173.027 310.119 172.763 310.685 172.756C311.25 172.752 311.714 173.009 311.725 173.332L311.767 174.858L318.121 174.91C318.687 174.914 319.14 175.181 319.129 175.504C319.122 175.826 318.655 176.083 318.089 176.08L310.744 176.021C310.467 176.021 310.217 175.955 310.034 175.851V175.844Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_261",
    d: "M347.629 168.799L347.612 174.346L316.029 192.464L316.047 186.916L347.629 168.799Z",
    fill: "url(#paint32_linear_600_71030)",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_262",
    d: "M316.047 186.916L316.029 192.464L279.352 171.557L279.369 166.01L316.047 186.916Z",
    fill: "url(#paint33_linear_600_71030)",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_263",
    d: "M331.703 154.162L331.735 159.737L347.629 168.8L316.047 186.917L279.369 166.01L315.812 145.104L331.703 154.162Z",
    fill: "#222222",
    stroke: "url(#paint34_linear_600_71030)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_264",
    d: "M313.499 171.845C319.155 171.845 323.74 169.232 323.74 166.009C323.74 162.787 319.155 160.174 313.499 160.174C307.844 160.174 303.259 162.787 303.259 166.009C303.259 169.232 307.844 171.845 313.499 171.845Z",
    fill: "url(#paint35_linear_600_71030)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_265",
    d: "M310.034 166.926C309.852 166.822 309.739 166.679 309.736 166.523L309.676 164.431C309.665 164.109 310.119 163.845 310.685 163.838C311.25 163.834 311.714 164.091 311.725 164.414L311.767 165.94L318.121 165.992C318.687 165.996 319.14 166.263 319.129 166.586C319.122 166.908 318.655 167.165 318.089 167.162L310.744 167.103C310.467 167.103 310.217 167.037 310.034 166.933V166.926Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_266",
    d: "M347.629 159.879L347.612 165.427L316.029 183.547L316.047 178L347.629 159.879Z",
    fill: "url(#paint36_linear_600_71030)",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_267",
    d: "M316.047 178L316.029 183.548L279.352 162.641L279.369 157.094L316.047 178Z",
    fill: "url(#paint37_linear_600_71030)",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_268",
    d: "M331.703 145.246L331.735 150.821L347.629 159.88L316.047 178L279.369 157.094L315.812 136.184L331.703 145.246Z",
    fill: "#222222",
    stroke: "url(#paint38_linear_600_71030)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_269",
    d: "M313.499 162.925C319.155 162.925 323.74 160.313 323.74 157.089C323.74 153.867 319.155 151.254 313.499 151.254C307.844 151.254 303.259 153.867 303.259 157.089C303.259 160.313 307.844 162.925 313.499 162.925Z",
    fill: "url(#paint39_linear_600_71030)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_270",
    d: "M310.034 158.006C309.852 157.902 309.739 157.759 309.736 157.603L309.676 155.511C309.665 155.189 310.119 154.925 310.685 154.918C311.25 154.915 311.714 155.171 311.725 155.494L311.767 157.02L318.121 157.073C318.687 157.076 319.14 157.343 319.129 157.666C319.122 157.988 318.655 158.245 318.089 158.242L310.744 158.183C310.467 158.183 310.217 158.117 310.034 158.013V158.006Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_271",
    d: "M347.629 150.959L347.612 156.507L316.029 174.627L316.047 169.08L347.629 150.959Z",
    fill: "url(#paint40_linear_600_71030)",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_272",
    d: "M316.047 169.081L316.029 174.628L279.352 153.722L279.369 148.174L316.047 169.081Z",
    fill: "url(#paint41_linear_600_71030)",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_273",
    d: "M331.703 136.326L331.735 141.902L347.629 150.96L316.047 169.081L279.369 148.174L315.812 127.268L331.703 136.326Z",
    fill: "#222222",
    stroke: "url(#paint42_linear_600_71030)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_274",
    d: "M313.499 154.009C319.155 154.009 323.74 151.396 323.74 148.173C323.74 144.951 319.155 142.338 313.499 142.338C307.844 142.338 303.259 144.951 303.259 148.173C303.259 151.396 307.844 154.009 313.499 154.009Z",
    fill: "url(#paint43_linear_600_71030)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_275",
    d: "M310.034 149.086C309.852 148.982 309.739 148.84 309.736 148.683L309.676 146.591C309.665 146.269 310.119 146.005 310.685 145.998C311.25 145.995 311.714 146.251 311.725 146.574L311.767 148.101L318.121 148.153C318.687 148.156 319.14 148.423 319.129 148.746C319.122 149.069 318.655 149.325 318.089 149.322L310.744 149.263C310.467 149.263 310.217 149.197 310.034 149.093V149.086Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_276",
    d: "M347.629 142.043L347.612 147.591L316.029 165.708L316.047 160.16L347.629 142.043Z",
    fill: "url(#paint44_linear_600_71030)",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_277",
    d: "M316.047 160.161L316.029 165.708L279.352 144.805L279.369 139.254L316.047 160.161Z",
    fill: "url(#paint45_linear_600_71030)",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_278",
    d: "M331.703 127.406L331.735 132.982L347.629 142.044L316.047 160.161L279.369 139.254L315.812 118.348L331.703 127.406Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_279",
    d: "M323.564 139.254C323.564 140.777 322.479 142.189 320.652 143.23C318.831 144.268 316.302 144.916 313.499 144.916C310.697 144.916 308.168 144.268 306.346 143.23C304.519 142.189 303.435 140.777 303.435 139.254C303.435 137.731 304.519 136.319 306.346 135.278C308.168 134.24 310.697 133.592 313.499 133.592C316.302 133.592 318.831 134.24 320.652 135.278C322.479 136.319 323.564 137.731 323.564 139.254Z",
    fill: "#222222",
    stroke: "url(#paint46_linear_600_71030)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_280",
    d: "M310.034 140.17C309.852 140.066 309.739 139.924 309.736 139.767L309.676 137.675C309.665 137.353 310.119 137.089 310.685 137.082C311.25 137.079 311.714 137.335 311.725 137.658L311.767 139.185L318.121 139.237C318.687 139.24 319.14 139.507 319.129 139.83C319.122 140.153 318.655 140.409 318.089 140.406L310.744 140.347C310.467 140.347 310.217 140.281 310.034 140.177V140.17Z",
    fill: "url(#paint47_linear_600_71030)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_600_71030",
    x1: 20.4059,
    y1: 271.665,
    x2: 120.559,
    y2: 258.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_600_71030",
    x1: 13.4688,
    y1: 58.2306,
    x2: 13.9343,
    y2: 57.2826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_600_71030",
    x1: 83.0345,
    y1: 10.2279,
    x2: 88.3629,
    y2: 7.15405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_600_71030",
    x1: 80.4427,
    y1: 11.7084,
    x2: 85.7711,
    y2: 8.63452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_600_71030",
    x1: 11.132,
    y1: 64.6845,
    x2: 11.5471,
    y2: 63.7135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_600_71030",
    x1: 4.91105,
    y1: 233.193,
    x2: 10.4491,
    y2: 230.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_600_71030",
    x1: 4.91105,
    y1: 241.201,
    x2: 10.4585,
    y2: 238.345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_600_71030",
    x1: 4.91105,
    y1: 244.453,
    x2: 10.4491,
    y2: 241.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_600_71030",
    x1: 5.8908,
    y1: 144.705,
    x2: 10.7132,
    y2: 144.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_600_71030",
    x1: 5.8908,
    y1: 126.238,
    x2: 10.7132,
    y2: 125.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_600_71030",
    x1: 5.8908,
    y1: 104.609,
    x2: 10.6744,
    y2: 104.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_600_71030",
    x1: 6.25967,
    y1: 98.5284,
    x2: 9.91146,
    y2: 97.7927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_600_71030",
    x1: 5.8908,
    y1: 99.0384,
    x2: 10.5172,
    y2: 98.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_600_71030",
    x1: 15.0157,
    y1: 55.6534,
    x2: 15.5049,
    y2: 54.7173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_600_71030",
    x1: 68.7094,
    y1: 165.555,
    x2: 74.1639,
    y2: 165.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_600_71030",
    x1: 40.1172,
    y1: 191.619,
    x2: 52.4903,
    y2: 185.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_600_71030",
    x1: 50.5523,
    y1: 150.545,
    x2: 86.8593,
    y2: 141.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_600_71030",
    x1: 61.2089,
    y1: 131.691,
    x2: 80.0073,
    y2: 126.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_600_71030",
    x1: 66.2733,
    y1: 125.826,
    x2: 72.6241,
    y2: 124.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_600_71030",
    x1: 37.4885,
    y1: 316.602,
    x2: 63.1784,
    y2: 304.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_600_71030",
    x1: 56.8194,
    y1: 308.997,
    x2: 58.6406,
    y2: 308.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_600_71030",
    x1: 146.455,
    y1: 325.041,
    x2: 205.107,
    y2: 286.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_600_71030",
    x1: 167.054,
    y1: 313.011,
    x2: 225.01,
    y2: 275.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_600_71030",
    x1: 184.279,
    y1: 303.918,
    x2: 242.931,
    y2: 265.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_600_71030",
    x1: 204.853,
    y1: 291.886,
    x2: 262.818,
    y2: 254.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_600_71030",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(250.44 325.754) rotate(-12.0911) scale(251.309 60.9665)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_600_71030",
    x1: 144.701,
    y1: 331.425,
    x2: 154.886,
    y2: 329.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_600_71030",
    x1: 155.827,
    y1: 337.776,
    x2: 166.012,
    y2: 336.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_600_71030",
    x1: 318.119,
    y1: 203.93,
    x2: 350.237,
    y2: 187.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_600_71030",
    x1: 281.778,
    y1: 204.228,
    x2: 318.486,
    y2: 185.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_600_71030",
    x1: 283.883,
    y1: 200.333,
    x2: 346.945,
    y2: 161.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_600_71030",
    x1: 304.613,
    y1: 182.02,
    x2: 322.758,
    y2: 170.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_600_71030",
    x1: 318.119,
    y1: 195.008,
    x2: 350.236,
    y2: 178.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_600_71030",
    x1: 281.778,
    y1: 195.308,
    x2: 318.486,
    y2: 176.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_600_71030",
    x1: 283.883,
    y1: 191.413,
    x2: 346.945,
    y2: 152.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_600_71030",
    x1: 304.613,
    y1: 173.1,
    x2: 322.758,
    y2: 161.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_600_71030",
    x1: 318.119,
    y1: 186.092,
    x2: 350.237,
    y2: 169.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_600_71030",
    x1: 281.778,
    y1: 186.392,
    x2: 318.486,
    y2: 167.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_600_71030",
    x1: 283.883,
    y1: 182.496,
    x2: 346.948,
    y2: 143.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_600_71030",
    x1: 304.613,
    y1: 164.18,
    x2: 322.758,
    y2: 152.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_600_71030",
    x1: 318.119,
    y1: 177.172,
    x2: 350.237,
    y2: 160.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_600_71030",
    x1: 281.778,
    y1: 177.472,
    x2: 318.486,
    y2: 158.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_600_71030",
    x1: 283.883,
    y1: 173.576,
    x2: 346.945,
    y2: 134.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_600_71030",
    x1: 304.613,
    y1: 155.264,
    x2: 322.758,
    y2: 143.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_600_71030",
    x1: 318.119,
    y1: 168.252,
    x2: 350.236,
    y2: 152.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_600_71030",
    x1: 281.778,
    y1: 168.553,
    x2: 318.486,
    y2: 149.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_600_71030",
    x1: 304.613,
    y1: 146.344,
    x2: 322.759,
    y2: 134.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_600_71030",
    x1: 310.301,
    y1: 140.763,
    x2: 315.9,
    y2: 134.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_600_71030"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69.2301,
    height: 83.9599,
    fill: "white",
    transform: "translate(279 118)"
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\t\t\t* {\n\t\t\tmargin: 0;\n\t\t\tbottom: 0;\n\t\t\tbox-sizing: border-box;\n\t\t\t}\n\t\t\t\n\t\t\t@-webkit-keyframes marker {\n\t\t\t0% {\n\t\t\tscale: 0.85;\n\t\t\t}\n\t\t\t50% {\n\t\t\tscale: 1;\n\t\t\t}\n\t\t\t100% {\n\t\t\tscale: 0.9;\n\t\t\t}\n\t\t\t}\n\t\t\t\n\t\t\t@keyframes marker {\n\t\t\t0% {\n\t\t\tscale: 0.85;\n\t\t\t}\n\t\t\t50% {\n\t\t\tscale: 1;\n\t\t\t}\n\t\t\t100% {\n\t\t\tscale: 0.9;\n\t\t\t}\n\t\t\t}\n\t\t\t\n\t\t\t@-webkit-keyframes parcel {\n\t\t\t0% {\n\t\t\t\topacity: 0;\n\t\t\ttransform: translate(8px, -72px);\n\t\t\t}\n\t\t\t5%{\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\t\t10% {\n\t\t\ttransform: translate(24px, -64px);\n\t\t\t}\n\t\t\t30% {\n\t\t\ttransform: translate(-31px, -26px);\n\t\t\t}\n\t\t\t50% {\n\t\t\ttransform: translate(-2px, -10px);\n\t\t\t}\n\t\t\t58% {\n\t\t\ttransform: translate(20px, -23px);\n\t\t\t}\n\t\t\t68% {\n\t\t\ttransform: translate(44px, -5px);\n\t\t\t}\n\t\t\t78% {\n\t\t\ttransform: translate(58px, -17px);\n\t\t\t}\n\t\t\t88% { \n\t\t\ttransform: translate(75px, 3px);\n\t\t\t}\n\t\t\t95% {\n\t\t\t\topacity : 1;\n\t\t\ttransform: translate(93px, -11px);\n\t\t\t}\n\t\t\t100% {\n\t\t\t\topacity : 0;\n\t\t\ttransform: translate(115px, -7px);\n\t\t\t}\n\t\t\t}\n\t\t\t \n\t\t\t\n\t\t\t@keyframes parcel {\n\t\t\t0% {\n\t\t\t\topacity: 0;\n\t\t\ttransform: translate(8px, -72px);\n\t\t\t}\n\t\t\t5%{\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\t\t10% {\n\t\t\ttransform: translate(24px, -64px);\n\t\t\t}\n\t\t\t30% {\n\t\t\ttransform: translate(-31px, -26px);\n\t\t\t}\n\t\t\t50% {\n\t\t\ttransform: translate(-2px, -10px);\n\t\t\t}\n\t\t\t58% {\n\t\t\ttransform: translate(20px, -23px);\n\t\t\t}\n\t\t\t68% {\n\t\t\ttransform: translate(44px, -5px);\n\t\t\t}\n\t\t\t78% {\n\t\t\ttransform: translate(58px, -17px);\n\t\t\t}\n\t\t\t88% { \n\t\t\ttransform: translate(75px, 3px);\n\t\t\t}\n\t\t\t95% {\n\t\t\t\topacity : 1;\n\t\t\ttransform: translate(93px, -11px);\n\t\t\t}\n\t\t\t100% {\n\t\t\t\topacity : 0;\n\t\t\ttransform: translate(115px, -7px);\n\t\t\t}\n\t\t\t}\n\t\t\t\n\t\t\t@-webkit-keyframes stacks {\n\t\t\t0% {\n\t\t\ttranslate: 0 0;\n\t\t\t}\n\t\t\t100% {\n\t\t\ttranslate: 0 60px;\n\t\t\t}\n\t\t\t}\n\t\t\t\n\t\t\t@keyframes stacks {\n\t\t\t0% {\n\t\t\ttranslate: 0 0;\n\t\t\t}\n\t\t\t100% {\n\t\t\ttranslate: 0 60px;\n\t\t\t}\n\t\t\t}\n\t\t\t\n\t\t\t.left-location-marker {\n\t\t\t-webkit-animation: marker 2s ease-in-out infinite alternate;\n\t\t\tanimation: marker 2s ease-in-out infinite alternate;\n\t\t\ttransform-origin: 69px 146px;\n\t\t\t}\n\t\t\t.left-delivery-parcel {\n\t\t\t-webkit-animation: parcel 10s linear infinite forwards;\n\t\t\tanimation: parcel 10s linear infinite forwards;\n\t\t\ttransform-origin: 61px 244px;\n\t\t\t}\n\t\t\t"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationLoginLeftNoAnim);
export default __webpack_public_path__ + "static/media/illustration-login-left-no-anim.b94b727051a588c8ce881c155f9cd6a0.svg";
export { ForwardRef as ReactComponent };